import React, { useState, useEffect } from "react";
import axios from "../../api/axios";
import { toast } from "react-toastify";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import Header from "../../layouts/Header";
import {
    Button,
    Col,
    Dropdown,
    Form,
    Modal,
    Row,
    Spinner,
    Table,
    OverlayTrigger,
    Tooltip,
    Card,
    Nav,
    Container,
    Tab,
} from "react-bootstrap";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";

const PurchaseList = () => {
    const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
    const [skin, setSkin] = useState(currentSkin);
    const { access } = useSelector((state) => state.login);
    const { email } = useSelector((state) => state.login);
    const [purchaseAccess, setPurchaseAccess] = useState([]);

    console.log("Access :", access);

    useEffect(() => {
        if (Array.isArray(access)) {
            const filteredAccess = access?.filter((perm) =>
                perm?.startsWith("PurchaseList:"),
            );
            setPurchaseAccess(filteredAccess);
        }
    }, [access]);

    console.log("Menu Access:", purchaseAccess);

    // Add all the state and functions from AddPurchase component here
    const [inputData, setInputData] = useState({
        vendor: "",
        idNumber: "",
        additionalCharges: "",
        procurementItems: [
            {
                material: "",
                quantity: "",
                rate: "",
                taxPercent: "",
            },
        ],
    });

    const [validationErrors, setValidationErrors] = useState({
        vendor: "",
        idNumber: "",
        additionalCharges: "",
        invoiceFile: "",
        procurementItems: [
            {
                material: "",
                quantity: "",
                rate: "",
            },
        ],
    });

    const [rawMaterialDetail, setRawMaterialDetail] = useState({});
    const [isPurchaseLoading, setIsPurchaseLoading] = useState(false);
    const [showAddPurchaseModal, setShowAddPurchaseModal] = useState(false);

    const accessToken = localStorage.getItem("authToken");
    const animatedComponents = makeAnimated();
    const [procurementsList, setProcurementsList] = useState([]);
    const [pagination, setPagination] = useState({ page: 1, recordsPerPage: 10 });
    const [openViewModal, setOpenViewModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [singleProcurementDetails, setSingleProcurementDetails] = useState({});
    const [singleProcurementItemsDetails, setSingleProcurementItemsDetails] =
        useState([]);
    const [editedData, setEditedData] = useState({});
    const [btnLoading, setBtnLoading] = useState(false);
    const [searchBtnLoading, setSearchBtnLoading] = useState(false);
    const [touched, setTouched] = useState(false);
    const [isEditBtnLoading, setIsEditBtnLoading] = useState(false);
    const [vendors, setVendors] = useState([]);
    const [selectedStorageLocation, setSelectedStorageLocation] = useState("");
    const [openAddProcurementItemModal, setOpenAddProcurementItemModal] =
        useState(false);
    const [procurementId, setProcurementId] = useState("");
    const [isAddItemBtnLoading, setIsAddItemBtnLoading] = useState(false);
    const [addProcurementItemDetails, setAddProcurementItemDetails] = useState({
        material: "",
        quantity: "",
        rate: "",
        taxPercent: "",
        taxAmount: "",
        taxable: "",
        grandTotal: "",
        unit: "",
    });
    const [rawMaterialList, setRawMaterialList] = useState([]);
    const [isDeleteBtnLoading, setIsDeleteBtnLoading] = useState(false);
    const [isStatusBtnLoading, setIsStatusBtnLoading] = useState(false);
    const [openUpdateStatusModal, setOpenUpdateStatusModal] = useState(false);
    const [openProcurementItemEditModal, setOpenProcurementItemEditModal] =
        useState(false);
    const [editProcurementItemDetails, setEditProcurementItemDetails] = useState(
        {},
    );
    const [isEditItemBtnLoading, setIsEditItemBtnLoading] = useState(false);
    const [openProcurementItemDeleteModal, setOpenProcurementDeleteModal] =
        useState(false);
    const [procurementItemIds, setProcurmentItemIds] = useState([]);
    const [isItemDeleteBtnLoading, setIsItemDeleteBtnLoading] = useState(false);
    const [openUpdateStatusItemModal, setOpenUpdateStatusItemModal] =
        useState(false);
    const [itemId, setItemId] = useState([]);
    const [isItemStatusBtnLoading, setIsItemStatusBtnLoading] = useState(false);
    const [invoiceFile, setInvoiceFile] = useState(null);
    const [openEditStatusWithRemarksModal, setOpenEditStatusWithRemarksModal] =
        useState(false);
    const [remark, setRemark] = useState("");
    const [isEditwithRemarkBtnLoading, setIsEditWithRemarkBtnLoading] =
        useState(false);

    const [editValidationErrors, setEditValidationErrors] = useState({
        vendor: "",
        idNumber: "",
        additionalCharges: "",
        scannedInvoice: "",
    });

    const [validateRemark, setValidateRemark] = useState("");
    const [searchText, setSearchText] = useState("");
    const [filteredData, setFilteredData] = useState([]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [error, setError] = useState("");
    const [selectedVendor, setSelectedVendor] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");
    const [currentPage, setCurrentPage] = useState("1");
    const [recordsPerPage, setRecordsPerPage] = useState("10");
    const [selectedSortBy, setSelectedSortBy] = useState("");
    const [totalRecords, setTotalRecords] = useState("");
    const [storageLocationList, setStorageLocationList] = useState([]);
    const [filterState, setFilterState] = useState("");
    const [filterCity, setFilterCity] = useState("");

    // State For Adding Raw Materials
    const [isLoading, setIsLoading] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    const [formData, setFormData] = useState({
        mainCategory: "",
        subCategory: "",
        name: "",
        reOrderLevel: "",
        description: "",
        unit: "",
        hsn: "",
        taxPercent: "",
        purchaseUnit: "",
    });
    const [mainCategories, setMainCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [filteredSubCategories, setFilteredSubCategories] = useState([]);

    useEffect(() => {
        getMainCategories();
        getSubCategories();
    }, [showAddModal])

    // Format options for react-select
    const mainCategoryOptions = mainCategories?.map(cat => ({
        value: cat._id,
        label: cat.name
    }));

    const subCategoryOptions = filteredSubCategories?.map(cat => ({
        value: cat._id,
        label: cat.name
    }));

    const getSubCategories = async (mainCategoryId = null) => {
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axios.get("masters/rm-sub-category/get", { headers });

            if (response?.data?.status === true) {
                const allSubCategories = response.data.data.categories;
                setSubCategories(allSubCategories);

                if (mainCategoryId) {
                    const filtered = allSubCategories.filter(sub => sub.mainCategory === mainCategoryId);
                    setFilteredSubCategories(filtered);
                }
            }
        } catch (error) {
            handleApiError(error, "Failed to fetch sub categories");
        }
    };

    const getMainCategories = async () => {
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axios.get("masters/rm-main-category/get", { headers });

            if (response?.data?.status === true) {
                setMainCategories(response.data.data.categories);
            }
        } catch (error) {
            handleApiError(error, "Failed to fetch main categories");
        }
    };

    // Helper functions
    const handleApiError = (error, defaultMessage) => {
        let errorMessage = defaultMessage;

        if (error?.response) {
            if (error.response.status === 400) {
                errorMessage = error.response.data.message || error.response.data.title;
            } else if (error.response.status === 404) {
                errorMessage = error.response.data.message || "Resource not found";
            } else if (error.response.status === 406) {
                errorMessage = error.response.data.error?.message || error.response.data.error;
            } else if (error.response.status === 412) {
                errorMessage = error.response.data.data?.message || error.response.data.error;
            } else if (error.response.status === 500) {
                errorMessage = error.response.data.error || "Server error";
            }
        }

        toast.error(errorMessage);
    };

    const handleOpenNewMaterialModal = () => {
        setShowAddModal(true);
    };

    const handleSelectChange = (selectedOption, field) => {
        setFormData(prev => ({ ...prev, [field]: selectedOption?.value || "" }));

        if (field === 'mainCategory') {
            getSubCategories(selectedOption?.value);
            setFormData(prev => ({ ...prev, subCategory: "" }));
        }
    };

    const resetForm = () => {
        setFormData({
            mainCategory: "",
            subCategory: "",
            name: "",
            reOrderLevel: "",
            description: "",
            unit: "",
            hsn: "",
            taxPercent: "",
            purchaseUnit: ""
        });
    };

    const handleFormChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const addMaterial = async (e) => {
        e.preventDefault();
        try {
            setIsLoading(true);
            const headers = { Authorization: `Bearer ${accessToken}` };
            const data = { ...formData };

            if (!data.reOrderLevel) delete data.reOrderLevel;
            if (!data.purchaseUnit) delete data.purchaseUnit;

            const response = await axios.post("raw-material", data, { headers });

            if (response?.data?.status === true) {
                toast.success(response.data.data.message);
                getRawMaterials();
                resetForm();
                setShowAddModal(false);
            }
        } catch (error) {
            handleApiError(error, "Failed to add material");
        } finally {
            setIsLoading(false);
        }
    };

    const [
        editProcurementItemValidationErrors,
        setEditProcurementItemValidationErrors,
    ] = useState({
        material: "",
        quantity: "",
        rate: "",
    });

    const rawMaterialOptions = rawMaterialList.map((rm) => ({
        value: rm._id,
        label: rm.name,
    }));

    const [filterLoading, setFilterLoading] = useState(false);

    const getProcurements = async (
        page,
        limit,
        sDate,
        eDate,
        vendor,
        status,
        search,
        sort,
    ) => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            let url = `procurement?page=${page}&limit=${limit}&fromDate=${sDate?.toISOString().split("T")[0]}&toDate=${eDate?.toISOString().split("T")[0]}`;

            if (vendor) {
                url += `&vendorId=${vendor}`;
            }

            if (status) {
                url += `&status=${status}`;
            }

            if (sort) {
                url += `&sort=${sort}`;
            }

            if (search) {
                url += `&search=${search}`;
            }

            console.log("Procurements URL :", url);

            const response = await axios.get(url, { headers });

            // const response = await axios.get("procurement", { headers });
            if (response?.data?.status === true) {
                console.log("procurements response :", response?.data?.data);

                // Dynamically assign serial numbers
                const startIndex = (page - 1) * limit; // Calculate the starting index
                const procList = response?.data?.data?.procurements.map(
                    (item, index) => ({
                        ...item,
                        serialNumber: startIndex + index + 1, // Adjust based on the current page
                    }),
                );

                setProcurementsList(procList);
                setFilteredData(procList);
                setTotalRecords(response?.data?.data?.pagination?.totalRecords);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                setProcurementsList([]);
                setFilteredData([]);
            }
        }
    };

    const handleOpenViewModal = (data) => {
        getSingleProcurementDetails(data?._id);
        console.log("Procurements data :", data);

        setOpenViewModal(true);
    };

    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
    };

    const getSingleProcurementDetails = async (procurementId) => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get(`procurement?_id=${procurementId}`, {
                headers,
            });

            if (response?.data?.status === true) {
                setSingleProcurementDetails(response?.data?.data?.procurements);
                setSingleProcurementItemsDetails(
                    response?.data?.data?.procurementItems,
                );

                console.log("response", response);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const handleEditModal = async (data) => {
        setOpenViewModal(false);
        setEditedData({
            _id: data._id,
            vendor: data.vendor._id,
            idNumber: data.idNumber,
            scannedInvoice: data.scannedInvoice,
            additionalCharges: data.additionalCharges,
        });
        setOpenEditModal(true);
    };

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        setInvoiceFile(selectedFile);
        setEditValidationErrors((prevErrors) => ({
            ...prevErrors,
            scannedInvoice: "",
        }));
    };

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        let sanitizedValue = value;

        // if (name === "additionalCharges") {
        //   // Ensure the value is a positive integer, removing any non-digit characters
        //   sanitizedValue = value.replace(/[^0-9]/g, '');
        // }

        setEditedData((prevState) => ({ ...prevState, [name]: sanitizedValue }));
        setEditValidationErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    };

    // const handleIdNumberChange = (e) => {
    //     const { name, value } = e.target;
    //     // Allow only underscores (_) and alphanumeric characters
    //     const sanitizedValue = value.replace(/[^a-zA-Z0-9_]/g, '');
    //     setEditedData((prevState) => ({ ...prevState, [name]: sanitizedValue }));
    //     setEditValidationErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    // };

    const handleIdNumberChange = (e) => {
        const { name, value } = e.target;

        // ✅ Allow everything (no regex, no filtering)
        setEditedData((prevState) => ({
            ...prevState,
            [name]: value,
        }));

        setEditValidationErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "",
        }));
    };

    const handleEditSubmit = async (e) => {
        e.preventDefault();

        if (!editedData.vendor) {
            setEditValidationErrors((prevErrors) => ({
                ...prevErrors,
                vendor: "Vendor is required.",
            }));
            return;
        }

        if (!editedData.idNumber) {
            setEditValidationErrors((prevErrors) => ({
                ...prevErrors,
                idNumber: "ID Number is required.",
            }));
            return;
        }

        if (!editedData.additionalCharges) {
            setEditValidationErrors((prevErrors) => ({
                ...prevErrors,
                additionalCharges: "Additional Charges is required.",
            }));
            return;
        }

        if (Object.values(editValidationErrors).some((error) => error !== "")) {
            return;
        }

        setIsEditBtnLoading(true);

        try {
            const formData = new FormData();
            formData.append(`procurement[_id]`, editedData._id);
            formData.append(`procurement[vendor]`, editedData.vendor);
            formData.append(`procurement[idNumber]`, editedData.idNumber);
            formData.append(
                `procurement[additionalCharges]`,
                editedData.additionalCharges,
            );
            formData.append(`procurement.scannedInvoice`, invoiceFile);

            const headers = {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${accessToken}`,
            };
            const data = {
                procurement: editedData,
            };

            const response = await axios.put("procurement", data, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999)); // start of day
                const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999)); // end of day
                getProcurements(
                    currentPage,
                    recordsPerPage,
                    adjustedStartDate,
                    adjustedEndDate,
                    selectedVendor,
                    selectedStatus,
                    searchText,
                    selectedSortBy,
                );
                getSingleProcurementDetails(editedData._id);
                setOpenEditModal(false);
                setOpenViewModal(true);
                setInvoiceFile(null);
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = "";
                if (error.response?.status === 406) {
                    errorMessage =
                        error?.response?.data?.error?.message ||
                        error?.response?.data?.error;
                } else if (error.response?.status === 412) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error;
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsEditBtnLoading(false);
        }
    };

    const handleCloseMainAddModal = () => {
        // Close modal and refresh data
        setShowAddPurchaseModal(false);
        setInputData({
            vendor: "",
            idNumber: "",
            additionalCharges: "",
            procurementItems: Array.from({ length: 1 }, () => ({
                material: "",
                quantity: "",
                rate: "",
            })),
        });
    };

    const handleOpenAddProcurementItemModal = (data) => {
        setOpenViewModal(false);
        setOpenAddProcurementItemModal(true);
        setProcurementId(data._id);
    };

    const handleAddProcurementItemChanges = (fieldNameOrEvent, value) => {
        let fieldName;
        let fieldValue;

        // Check if the first argument is an event (standard input)
        if (fieldNameOrEvent?.target) {
            fieldName = fieldNameOrEvent.target.name;
            fieldValue = fieldNameOrEvent.target.value;
        } else {
            // Handle React Select case
            fieldName = fieldNameOrEvent;
            fieldValue = value;
        }

        if (fieldName === "material") {
            getSingleRawMaterialDetail(fieldValue);
        }

        setAddProcurementItemDetails((prevState) => {
            const updatedState = { ...prevState, [fieldName]: fieldValue };

            console.log("updatedState", updatedState);

            const { taxAmount, taxable, grandTotal } = calculateTaxAmount(
                updatedState.rate,
                updatedState.quantity,
                updatedState.taxPercent,
            );
            return {
                ...updatedState,
                taxAmount,
                taxable,
                grandTotal,
            };
        });
    };

    const addProcurementItem = async (e) => {
        e.preventDefault();
        setIsAddItemBtnLoading(true);
        try {
            const formData = new FormData();
            formData.append(`procurement[_id]`, procurementId);
            formData.append(
                `procurementItem[material]`,
                addProcurementItemDetails.material,
            );
            formData.append(
                `procurementItem[quantity]`,
                addProcurementItemDetails.quantity,
            );
            formData.append(`procurementItem[rate]`, addProcurementItemDetails.rate);

            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            const response = await axios.put("procurement", formData, { headers });

            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                setAddProcurementItemDetails({
                    material: "",
                    quantity: "",
                    rate: "",
                });
                const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999)); // start of day
                const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999)); // end of day
                getProcurements(
                    currentPage,
                    recordsPerPage,
                    adjustedStartDate,
                    adjustedEndDate,
                    selectedVendor,
                    selectedStatus,
                    searchText,
                    selectedSortBy,
                );
                getSingleProcurementDetails(procurementId);
                setOpenAddProcurementItemModal(false);
                setOpenViewModal(true);
                setProcurementId("");
            }
        } catch (error) {
            console.log(error.response);

            if (error?.response) {
                let errorMessage = "";
                if (error.response?.status === 406) {
                    errorMessage =
                        error?.response?.data?.error?.message ||
                        error?.response?.data?.error;
                } else if (error.response?.status === 412) {
                    errorMessage =
                        error?.response?.data?.data?.message ||
                        error?.response?.data?.data?.title;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error;
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsAddItemBtnLoading(false);
        }
    };

    const handleDeleteModal = async (data) => {
        setOpenDeleteModal(true);
        setProcurementId(data?._id);
    };

    const handleDeleteProcurement = async (e) => {
        e.preventDefault();
        setIsDeleteBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            const data = {
                procurementId,
            };

            const response = await axios.delete(`procurement`, { data, headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                setProcurementId("");
                const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999)); // start of day
                const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999)); // end of day
                getProcurements(
                    currentPage,
                    recordsPerPage,
                    adjustedStartDate,
                    adjustedEndDate,
                    selectedVendor,
                    selectedStatus,
                    searchText,
                    selectedSortBy,
                );
                setOpenDeleteModal(false);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsDeleteBtnLoading(false);
        }
    };

    const handleOpenUpdateStatusModal = (data) => {
        setOpenUpdateStatusModal(true);
        setProcurementId(data._id);
    };

    const handleProcurementUpdateStatus = async (e) => {
        e.preventDefault();
        setIsStatusBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            const data = {
                procurementId,
                storageLocation: selectedStorageLocation,
            };

            const response = await axios.put("procurement/status", data, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });

                setProcurementId("");
                const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999)); // start of day
                const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999)); // end of day
                getProcurements(
                    currentPage,
                    recordsPerPage,
                    adjustedStartDate,
                    adjustedEndDate,
                    selectedVendor,
                    selectedStatus,
                    searchText,
                    selectedSortBy,
                );
                setOpenUpdateStatusModal(false);
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = "";
                if (error.response?.status === 406) {
                    errorMessage =
                        error?.response?.data?.error?.message ||
                        error?.response?.data?.error;
                } else if (error.response?.status === 412) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error;
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsStatusBtnLoading(false);
        }
    };

    const handleOpenProcurementItemEditModal = (data) => {
        console.log("data", data);

        setOpenViewModal(false);
        setOpenProcurementItemEditModal(true);
        setProcurementId(singleProcurementDetails._id);

        // Calculate actualRate based on unit
        let actualRate = data.rate || 0;
        const unit = data?.material?.unit || "";
        const quantity = data.quantity || 0;

        if (unit === "GRAMS" || unit === "ML") {
            actualRate = data.rate * data.quantity;
        }

        setEditProcurementItemDetails({
            _id: data._id,
            material: data.material?._id || "", // Safely access material._id
            quantity: data.quantity || 0,
            rate: data.rate || 0,
            taxAmount: data?.taxAmount || 0,
            taxable: data?.taxable || 0,
            grandTotal: data?.grandTotal || 0,
            taxPercent: data?.material?.taxPercent || 0, // Safely access taxPercent
            unit: unit,
            actualRate: Number(actualRate.toFixed(2)), // Add this
        });
    };

    // const handleEditProcurementItemChange = (name, value) => {
    //   setEditProcurementItemDetails((prevState) => {
    //     const updatedState = { ...prevState, [name]: value };

    //     // Recalculate amounts if rate, quantity, or taxPercent changes
    //     const { taxAmount, taxable, grandTotal } = calculateTaxAmount(
    //       updatedState.rate,
    //       updatedState.quantity,
    //       updatedState.taxPercent
    //     );

    //     return {
    //       ...updatedState,
    //       taxAmount,
    //       taxable,
    //       grandTotal,
    //     };
    //   });

    //   // Reset validation error for the field
    //   setEditProcurementItemValidationErrors((prevErrors) => ({
    //     ...prevErrors,
    //     [name]: "",
    //   }));
    // };

    const handleEditProcurementItemChange = (name, value) => {
        setEditProcurementItemDetails((prevState) => {
            const updatedState = { ...prevState, [name]: value };

            // If material is changed, fetch taxPercent and unit
            if (name === "material" && value) {
                getSingleRawMaterialDetail(value); // Fetch and update taxPercent and unit
            }

            // Recalculate amounts if rate, quantity, or taxPercent changes
            const { taxAmount, taxable, grandTotal } = calculateTaxAmount(
                updatedState.rate,
                updatedState.quantity,
                updatedState.taxPercent,
            );

            return {
                ...updatedState,
                taxAmount,
                taxable,
                grandTotal,
            };
        });

        // Reset validation error for the field
        setEditProcurementItemValidationErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "",
        }));
    };

    const handleEditProcurementItemSubmit = async (e) => {
        e.preventDefault();
        if (!editProcurementItemDetails.material) {
            setEditProcurementItemValidationErrors((prevErrors) => ({
                ...prevErrors,
                material: "Material is required.",
            }));
            return;
        }
        if (!editProcurementItemDetails.quantity) {
            setEditProcurementItemValidationErrors((prevErrors) => ({
                ...prevErrors,
                quantity: "Quantity is required.",
            }));
            return;
        }
        if (!editProcurementItemDetails.rate) {
            setEditProcurementItemValidationErrors((prevErrors) => ({
                ...prevErrors,
                rate: "Rate is required.",
            }));
            return;
        }
        setIsEditItemBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            const formData = new FormData();
            formData.append(`procurement[_id]`, procurementId);
            formData.append(`procurementItem[_id]`, editProcurementItemDetails._id);
            formData.append(
                `procurementItem[material]`,
                editProcurementItemDetails.material,
            );
            formData.append(
                `procurementItem[quantity]`,
                editProcurementItemDetails.quantity,
            );
            formData.append(`procurementItem[rate]`, editProcurementItemDetails.rate);

            const response = await axios.put("procurement", formData, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999)); // start of day
                const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999)); // end of day
                getProcurements(
                    currentPage,
                    recordsPerPage,
                    adjustedStartDate,
                    adjustedEndDate,
                    selectedVendor,
                    selectedStatus,
                    searchText,
                    selectedSortBy,
                );
                setOpenProcurementItemEditModal(false);
                setOpenViewModal(true);
                getSingleProcurementDetails(singleProcurementDetails._id);
                setProcurementId("");
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = "";
                if (error.response?.status === 406) {
                    errorMessage =
                        error?.response?.data?.error?.message ||
                        error?.response?.data?.error;
                } else if (error.response?.status === 412) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error;
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsEditItemBtnLoading(false);
        }
    };

    const handleOpenProcurementItemDeleteModal = (data) => {
        setOpenViewModal(false);
        setOpenProcurementDeleteModal(true);
        setProcurementId(data.procurement);
        setProcurmentItemIds((prevIds) => [...prevIds, data._id]);
    };

    const handleDeleteProcurementItems = async (e) => {
        e.preventDefault();
        setIsItemDeleteBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const data = {
                procurementItemIds: procurementItemIds,
            };

            const response = await axios.delete("procurement", { data, headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
                const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999)); // start of day
                const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999)); // end of day
                getProcurements(
                    currentPage,
                    recordsPerPage,
                    adjustedStartDate,
                    adjustedEndDate,
                    selectedVendor,
                    selectedStatus,
                    searchText,
                    selectedSortBy,
                );
                setProcurmentItemIds([]);
                setOpenProcurementDeleteModal(false);
                getSingleProcurementDetails(procurementId);
                setOpenViewModal(true);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsItemDeleteBtnLoading(false);
        }
    };

    const handleOpenProcurementItemUpdateStatus = (data) => {
        setOpenViewModal(false);
        setOpenUpdateStatusItemModal(true);
        setItemId((prevIds) => [...prevIds, data._id]);
    };

    const handleProcurementItemUpdateStatus = async (e) => {
        e.preventDefault();
        setIsItemStatusBtnLoading(true);

        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            const data = {
                procurementItemIds: itemId,
                storageLocation: selectedStorageLocation,
            };

            const response = await axios.put("procurement/status", data, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });

                setProcurementId("");
                setItemId([]);
                const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999)); // start of day
                const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999)); // end of day
                getProcurements(
                    currentPage,
                    recordsPerPage,
                    adjustedStartDate,
                    adjustedEndDate,
                    selectedVendor,
                    selectedStatus,
                    searchText,
                    selectedSortBy,
                );
                setOpenUpdateStatusItemModal(false);
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = "";
                if (error.response?.status === 406) {
                    errorMessage =
                        error?.response?.data?.error?.message ||
                        error?.response?.data?.error;
                } else if (error.response?.status === 412) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error;
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsItemStatusBtnLoading(false);
        }
    };

    const handleOpenEditStatusWithRemarksModal = (data) => {
        setProcurementId(data._id);
        setOpenViewModal(false);
        setOpenEditStatusWithRemarksModal(true);
    };

    const handleEditStatusWithRemarksSubmit = async (e) => {
        e.preventDefault();

        if (!remark) {
            setValidateRemark("Remark is required");
            return;
        }

        setIsEditWithRemarkBtnLoading(true);

        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            const data = {
                storageLocation: selectedStorageLocation,
                procurementId: procurementId,
                remark: remark,
            };

            const response = await axios.put("procurement/status", data, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999)); // start of day
                const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999)); // end of day
                getProcurements(
                    currentPage,
                    recordsPerPage,
                    adjustedStartDate,
                    adjustedEndDate,
                    selectedVendor,
                    selectedStatus,
                    searchText,
                    selectedSortBy,
                );
                getSingleProcurementDetails(procurementId);
                setOpenEditStatusWithRemarksModal(false);
                setOpenViewModal(true);
                setProcurementId("");
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = "";
                if (error.response?.status === 406) {
                    errorMessage =
                        error?.response?.data?.error?.message ||
                        error?.response?.data?.error;
                } else if (error.response?.status === 412) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error;
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsEditWithRemarkBtnLoading(false);
        }
    };

    const getVendors = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("vendor", { headers });
            if (response?.data?.status === true) {
                setVendors(response?.data?.data?.vendors);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const getRawMaterials = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("raw-material", { headers });

            if (response?.data?.status === true) {
                setRawMaterialList(response?.data?.data?.rawMaterials);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const getSingleRawMaterialDetail = async (materialId) => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get(`raw-material?_id=${materialId}`, {
                headers,
            });

            if (response?.data?.status === true) {
                const taxPercent = response?.data?.data?.rawMaterials?.taxPercent;
                const unit = response?.data?.data?.rawMaterials?.unit;
                setAddProcurementItemDetails((prevState) => ({
                    ...prevState,
                    taxPercent: taxPercent,
                    unit: unit,
                }));
                setEditProcurementItemDetails((prevState) => ({
                    ...prevState,
                    taxPercent: taxPercent,
                    unit: unit,
                }));
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    //   const calculateTaxAmount = (rate, quantity, taxPercent) => {
    //     const taxable = quantity * rate;
    //     const taxAmount = (taxable * taxPercent) / 100;
    //     const grandTotal = taxAmount + taxable;
    //     return {
    //       taxAmount,
    //       taxable,
    //       grandTotal,
    //     };
    //   };

    const calculateTaxAmount = (
        rate,
        quantity,
        taxPercent,
        unit,
        actualRate
    ) => {
        let taxable = 0;

        if (unit === "GRAMS" || unit === "ML") {
            taxable = actualRate * (quantity / 1000);
        } else {
            taxable = rate * quantity;
        }

        taxable = Number(taxable.toFixed(2));

        const taxAmount = Number(((taxable * taxPercent) / 100).toFixed(2));
        const grandTotal = Number((taxable + taxAmount).toFixed(2));

        return { taxable, taxAmount, grandTotal };
    };


    const handleCloseAddProcurementItemModal = () => {
        setAddProcurementItemDetails({
            material: "",
            quantity: "",
            rate: "",
            taxPercent: "",
            taxAmount: "",
            taxable: "",
            grandTotal: "",
            unit: "",
        });
        setOpenAddProcurementItemModal(false);
    };

    // const handlePageChange = (page) => {
    //   setPagination({ ...pagination, page });
    // };

    // const handlerecordsPerPageChange = (recordsPerPage) => {
    //   setPagination({ page: 1, recordsPerPage }); // Reset to the first page when changing rows per page
    // };

    // Function to get paginated data
    const getPaginatedData = () => {
        const startIndex = (pagination.page - 1) * pagination.recordsPerPage;
        const endIndex = startIndex + pagination.recordsPerPage;
        return filteredData?.slice(startIndex, endIndex);
    };

    const totals = singleProcurementItemsDetails?.reduce(
        (acc, item) => {
            const taxable = item?.quantity * item?.rate;
            const taxAmount = taxable * (item?.material?.taxPercent / 100);
            const additionalCharges =
                singleProcurementDetails?.additionalCharges || 0;
            const grandTotal = taxable + taxAmount + additionalCharges;

            acc.totalTaxable += taxable;
            acc.totalTaxAmount += taxAmount;
            acc.totalAdditionalCharges += additionalCharges;
            acc.totalGrandTotal += grandTotal;

            return acc;
        },
        {
            totalTaxable: 0,
            totalTaxAmount: 0,
            totalAdditionalCharges: 0,
            totalGrandTotal: 0,
        },
    );

    const handleEndDateChange = (date) => {
        if (date && startDate && date < startDate) {
            setError("End date cannot be earlier than start date");
        } else {
            setError("");
            setEndDate(date);
        }
    };

    const handleChange = (vendor) => {
        setSelectedVendor(vendor);
    };

    const handleSubmitFilters = async () => {
        setBtnLoading(true);
        const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999)); // start of day
        const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999)); // end of day

        getProcurements(
            currentPage,
            recordsPerPage,
            adjustedStartDate,
            adjustedEndDate,
            selectedVendor,
            selectedStatus,
            searchText,
            selectedSortBy,
        );
        setBtnLoading(false);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
        const adjustedStartDate = startDate
            ? new Date(new Date(startDate).setHours(23, 59, 59, 999))
            : null;
        const adjustedEndDate = endDate
            ? new Date(new Date(endDate).setHours(23, 59, 59, 999))
            : null;
        // API should expect 1-based page index
        getProcurements(
            page,
            recordsPerPage,
            adjustedStartDate,
            adjustedEndDate,
            selectedVendor,
            selectedStatus,
            searchText,
            selectedSortBy,
        );
    };

    const handlerecordsPerPageChange = (newPerPage) => {
        setRecordsPerPage(newPerPage);
        // Reset to first page when page size changes
        setCurrentPage(1);

        const adjustedStartDate = startDate
            ? new Date(new Date(startDate).setHours(23, 59, 59, 999))
            : null;
        const adjustedEndDate = endDate
            ? new Date(new Date(endDate).setHours(23, 59, 59, 999))
            : null;
        getProcurements(
            1,
            newPerPage,
            adjustedStartDate,
            adjustedEndDate,
            selectedVendor,
            selectedStatus,
            searchText,
            selectedSortBy,
        );
    };

    // const getStorageLocation = async() => {
    //   try {
    //       const headers = {
    //           Authorization : `Bearer ${accessToken}`
    //       }
    //       const response = await axios.get('storage-location', { headers })
    //       setStorageLocationList(response?.data?.data?.storageLocations);
    //   } catch (error) {
    //       if (error.response && error.response?.data?.status === false) {
    //           let errorMessage = error.response.data.error;
    //           toast.error(errorMessage, {
    //             position: "top-right",
    //             autoClose: 3000,
    //             theme: "colored",
    //           });
    //       }
    //   }
    // };

    // Function to fetch storage locations with filters
    const handleFilter = async () => {
        setFilterLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const params = {};

            if (filterState) params.state = filterState;
            if (filterCity) params.city = filterCity;

            const response = await axios.get("storage-location", {
                headers,
                params, // Include filters as query parameters
            });
            console.log("Response :", response);

            setStorageLocationList(response?.data?.data?.storageLocations);
            if (filterState !== "" || filterCity !== "") {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                const errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setFilterLoading(false);
        }
    };

    const resetModalFields = () => {
        setFilterCity("");
        setFilterState("");
        setSelectedStorageLocation("");
        setFilterLoading(false); // Optional: Reset loading if needed
    };

    useEffect(() => {
        // Fetch all storage locations on initial load
        handleFilter();
    }, []);

    useEffect(() => {
        const now = new Date();
        const firstOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
        const currentDate = new Date(
            now.getFullYear(),
            now.getMonth(),
            now.getDate(),
        );

        const start = new Date(firstOfMonth.setHours(23, 59, 59, 999)); // start of day
        const end = new Date(currentDate.setHours(23, 59, 59, 999)); // end of day
        // Set the start date and end date
        setStartDate(start);
        setEndDate(end);
        // getProductData(start, end, selectedOutlet, selectedCategory);

        getProcurements(currentPage, recordsPerPage, start, end);
    }, []);

    useEffect(() => {
        getVendors();
        getRawMaterials();
        // getStorageLocation();
    }, []);

    useEffect(() => {
        const result = procurementsList.filter((item) => {
            return (
                (item.vendor.name &&
                    item.vendor.name.toLowerCase().includes(searchText.toLowerCase())) ||
                (item.vendor.email &&
                    item.vendor.email.toLowerCase().includes(searchText.toLowerCase())) ||
                (item.vendor.phone &&
                    item.vendor.phone.toLowerCase().includes(searchText.toLowerCase())) ||
                (item.scannedInvoice &&
                    item.scannedInvoice
                        .toLowerCase()
                        .includes(searchText.toLowerCase())) ||
                (item.status &&
                    item.status.toLowerCase().includes(searchText.toLowerCase())) ||
                (item.idNumber && item.idNumber.toString().includes(searchText)) ||
                (item.financialYear &&
                    item.financialYear.toString().includes(searchText)) ||
                (item.additionalCharges &&
                    item.additionalCharges.toString().includes(searchText)) ||
                (item.totalTaxAmount &&
                    item.totalTaxAmount.toString().includes(searchText)) ||
                (item.taxable && item.taxable.toString().includes(searchText)) ||
                (item.grandTotal && item.grandTotal.toString().includes(searchText))
            );
        });
        setFilteredData(result);
    }, [procurementsList]);

    useEffect(() => {
        if (!searchText && touched) {
            const adjustedStartDate = new Date(startDate?.setHours(23, 59, 59, 999)); // start of day
            const adjustedEndDate = new Date(endDate?.setHours(23, 59, 59, 999)); // end of day
            getProcurements(
                currentPage,
                recordsPerPage,
                adjustedStartDate,
                adjustedEndDate,
            );
        }
    }, [searchText]);

    // Add all the handler functions from AddPurchase component here
    const handleAddItem = () => {
        const procurementItemErrors = inputData.procurementItems.map(
            validateProcurementItem,
        );
        if (
            procurementItemErrors.some((errors) => Object.keys(errors).length > 0)
        ) {
            setValidationErrors((prevErrors) => ({
                ...prevErrors,
                procurementItems: procurementItemErrors,
            }));
            return;
        }

        setInputData((prevData) => ({
            ...prevData,
            procurementItems: [
                ...prevData.procurementItems,
                {
                    material: "",
                    quantity: "",
                    rate: "",
                    taxPercent: "",
                },
            ],
        }));
    };

    const handleRemoveItem = (index) => {
        setInputData((prevData) => {
            const updatedItems = [...prevData.procurementItems];
            updatedItems.splice(index, 1);
            return {
                ...prevData,
                procurementItems: updatedItems,
            };
        });
    };

    // const handlePurchaseChange = (e, index) => {
    //     const { name, value } = e.target;

    //     // ✅ Allow EVERYTHING for idNumber
    //     if (name === "idNumber") {
    //         setValidationErrors((prevErrors) => ({
    //             ...prevErrors,
    //             idNumber: ""
    //         }));

    //         setInputData((prevData) => ({
    //             ...prevData,
    //             idNumber: value, // no sanitization
    //         }));

    //         return; // ⛔ VERY IMPORTANT
    //     }

    //     let sanitizedValue = value;

    //     setValidationErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    //     setValidationErrors((prevErrors) => ({
    //         ...prevErrors,
    //         procurementItems: [],
    //     }));

    //     if (name === "material" || name === "quantity" || name === "rate") {
    //         if (name === "material") {
    //             getSingleRawMaterialDetail(value, index);
    //         }

    //         setInputData((prevData) => {
    //             const updatedProcurementItems = [...prevData.procurementItems];
    //             updatedProcurementItems[index] = {
    //                 ...updatedProcurementItems[index],
    //                 [name]: value,
    //             };

    //             const { taxAmount, taxable, grandTotal } = calculateTaxAmount(
    //                 updatedProcurementItems[index].rate,
    //                 updatedProcurementItems[index].quantity,
    //                 updatedProcurementItems[index].taxPercent
    //             );

    //             updatedProcurementItems[index] = {
    //                 ...updatedProcurementItems[index],
    //                 taxable,
    //                 taxAmount,
    //                 grandTotal,
    //             };

    //             return {
    //                 ...prevData,
    //                 procurementItems: updatedProcurementItems,
    //             };
    //         });
    //     } else {
    //         setInputData((prevData) => ({
    //             ...prevData,
    //             [name]: sanitizedValue,
    //         }));
    //     }
    // };

    //   const handlePurchaseChange = (e, index) => {
    //     const { name, value } = e.target;

    //     // ✅ idNumber special case
    //     if (name === "idNumber") {
    //       setValidationErrors((prev) => ({ ...prev, idNumber: "" }));
    //       setInputData((prev) => ({ ...prev, idNumber: value }));
    //       return;
    //     }

    //     setValidationErrors((prev) => ({ ...prev, [name]: "" }));
    //     setValidationErrors((prev) => ({ ...prev, procurementItems: [] }));

    //     // ✅ PROCUREMENT ITEM FIELDS
    //     if (["material", "quantity", "rate"].includes(name)) {
    //       if (name === "material") {
    //         getSingleRawMaterialDetail(value, index);
    //       }

    //       setInputData((prev) => {
    //         const items = [...prev.procurementItems];
    //         const item = { ...items[index] };

    //         // ✅ correct typing
    //         if (name === "material") {
    //           item.material = value; // string
    //         } else {
    //           item[name] = parseFloat(value) || 0; // number
    //         }

    //         const rate = Number(item.rate) || 0;
    //         const quantity = Number(item.quantity) || 0;
    //         const taxPercent = Number(item.taxPercent) || 0;

    //         const { taxable, taxAmount, grandTotal } = calculateTaxAmount(
    //   rate,
    //   quantity,
    //   taxPercent,
    //   item.unit,
    //   item.actualRate
    // );

    //         items[index] = {
    //           ...item,
    //           taxable: Number(taxable.toFixed(2)),
    //           taxAmount: Number(taxAmount.toFixed(2)),
    //           grandTotal: Number(grandTotal.toFixed(2)),
    //         };

    //         return { ...prev, procurementItems: items };
    //       });

    //       return;
    //     }

    //     // ✅ OTHER FIELDS
    //     setInputData((prev) => ({
    //       ...prev,
    //       [name]: value,
    //     }));
    //   };

    const handlePurchaseChange = (e, index) => {
        const { name, value } = e.target;

        // ✅ idNumber special case
        if (name === "idNumber") {
            setValidationErrors((prev) => ({ ...prev, idNumber: "" }));
            setInputData((prev) => ({ ...prev, idNumber: value }));
            return;
        }

        setValidationErrors((prev) => ({ ...prev, [name]: "" }));
        setValidationErrors((prev) => ({ ...prev, procurementItems: [] }));

        // ✅ PROCUREMENT ITEM FIELDS
        if (["material", "quantity", "rate"].includes(name)) {

            if (name === "material") {
                getSingleRawMaterialDetail(value, index);
            }

            setInputData((prev) => {
                const items = [...prev.procurementItems];
                const item = { ...items[index] };

                // 🔥 RESET ALL DEPENDENT FIELDS WHEN MATERIAL CHANGES
                if (name === "material") {
                    items[index] = {
                        ...item,
                        material: value,

                        quantity: "",
                        rate: "",
                        actualRate: "",

                        taxable: 0,
                        taxAmount: 0,
                        grandTotal: 0,

                        // unit & taxPercent will be updated by API
                    };

                    return { ...prev, procurementItems: items };
                }

                // ✅ quantity / rate flow
                item[name] = parseFloat(value) || 0;

                const rate = Number(item.rate) || 0;
                const quantity = Number(item.quantity) || 0;
                const taxPercent = Number(item.taxPercent) || 0;

                const { taxable, taxAmount, grandTotal } = calculateTaxAmount(
                    rate,
                    quantity,
                    taxPercent,
                    item.unit,
                    item.actualRate
                );

                items[index] = {
                    ...item,
                    taxable: Number(taxable.toFixed(2)),
                    taxAmount: Number(taxAmount.toFixed(2)),
                    grandTotal: Number(grandTotal.toFixed(2)),
                };

                return { ...prev, procurementItems: items };
            });

            return;
        }

        // ✅ OTHER FIELDS
        setInputData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };


    const handlePurchaseFileChange = (e) => {
        setValidationErrors((prevErrors) => ({ ...prevErrors, invoiceFile: "" }));
        const selectedFile = e.target.files[0];
        setInvoiceFile(selectedFile);
    };

    const validateProcurementItem = (item) => {
        const errors = {};

        // ✅ material is string
        if (!item.material || !item.material.trim()) {
            errors.material = "Material is required.";
        }

        // ✅ quantity is number
        if (item.quantity === null || item.quantity === undefined || Number(item.quantity) <= 0) {
            errors.quantity = "Quantity must be greater than 0.";
        }

        // ✅ rate is number
        if (item.rate === null || item.rate === undefined || Number(item.rate) <= 0) {
            errors.rate = "Rate must be greater than 0.";
        }

        return errors;
    };


    const handlePurchaseSubmit = async (e) => {
        e.preventDefault();
        if (!inputData.vendor) {
            setValidationErrors((prevErrors) => ({
                ...prevErrors,
                vendor: "Vendor is required.",
            }));
            return;
        }

        if (!inputData.idNumber) {
            setValidationErrors((prevErrors) => ({
                ...prevErrors,
                idNumber: "ID Number is required.",
            }));
            return;
        }

        if (!inputData.additionalCharges) {
            setValidationErrors((prevErrors) => ({
                ...prevErrors,
                additionalCharges: "Additional Charges is required.",
            }));
            return;
        }

        const procurementItemErrors = inputData.procurementItems.map(
            validateProcurementItem,
        );
        if (
            procurementItemErrors.some((errors) => Object.keys(errors).length > 0)
        ) {
            setValidationErrors((prevErrors) => ({
                ...prevErrors,
                procurementItems: procurementItemErrors,
            }));
            return;
        }

        setIsPurchaseLoading(true);

        try {
            const formData = new FormData();
            formData.append("procurement[vendor]", inputData.vendor);
            formData.append("procurement[idNumber]", inputData.idNumber);
            formData.append(
                "procurement[additionalCharges]",
                inputData.additionalCharges,
            );
            formData.append("procurement.scannedInvoice", invoiceFile);
            inputData.procurementItems.forEach((item, index) => {
                formData.append(`procurementItems[${index}][material]`, item.material);
                formData.append(`procurementItems[${index}][quantity]`, item.quantity);
                formData.append(`procurementItems[${index}][rate]`, item.rate);
            });

            const headers = {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${accessToken}`,
            };

            const response = await axios.post("procurement", formData, { headers });

            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                e.target.reset();
                setInputData({
                    vendor: "",
                    idNumber: "",
                    additionalCharges: "",
                    procurementItems: Array.from({ length: 1 }, () => ({
                        material: "",
                        quantity: "",
                        rate: "",
                    })),
                });
                // Close modal and refresh data
                setShowAddPurchaseModal(false);
                const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
                const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));
                getProcurements(
                    currentPage,
                    recordsPerPage,
                    adjustedStartDate,
                    adjustedEndDate,
                );
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = "";
                if (error.response?.status === 406) {
                    errorMessage =
                        error?.response?.data?.error?.message ||
                        error?.response?.data?.error;
                } else if (error.response?.status === 412) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error;
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsPurchaseLoading(false);
        }
    };

    const purchaseBtnDisable = () => {
        let isDisable = false;

        if (
            !inputData.vendor ||
            !inputData.idNumber ||
            !inputData.additionalCharges
        ) {
            isDisable = true;
        }

        for (let i = 0; i < inputData.procurementItems.length; i++) {
            const item = inputData.procurementItems[i];

            if (!item.material || !item.quantity || !item.rate) {
                isDisable = true;
                break;
            }
        }

        return isDisable;
    };

    // const handleRateChange = (e, index) => {
    //     const { value } = e.target;
    //     const actualRate = parseFloat(value) || 0;

    //     setInputData((prev) => {
    //         const items = [...prev.procurementItems];
    //         const item = items[index];

    //         const quantity = parseFloat(item.quantity) || 0;
    //         const unit = item.unit;

    //         let calculatedRate = actualRate;

    //         // ✅ Special logic for GRAMS or ML
    //         if ((unit === "GRAMS" || unit === "ML") && actualRate > 0) {
    //             calculatedRate = quantity / actualRate;
    //         }

    //         // ✅ force 2 decimal places
    //         calculatedRate = Number(calculatedRate.toFixed(2));

    //         items[index] = {
    //             ...item,
    //             rate: calculatedRate,
    //             actualRate: actualRate,
    //         };

    //         handlePurchaseChange(
    //             { target: { name: "rate", value: calculatedRate } },
    //             index
    //         );

    //         return {
    //             ...prev,
    //             procurementItems: items,
    //         };
    //     });
    // };

    // Add the AddPurchase JSX as a modal

    const handleRateChange = (e, index) => {
        const actualRate = parseFloat(e.target.value) || 0;

        setInputData((prev) => {
            const items = [...prev.procurementItems];
            const item = { ...items[index] };

            const quantity = parseFloat(item.quantity) || 0;
            const unit = item.unit;

            let rate = actualRate;

            // ✅ correct per-unit rate
            if ((unit === "GRAMS" || unit === "ML") && actualRate > 0 && quantity > 0) {
                rate = actualRate / quantity;
            }

            rate = Number(rate.toFixed(5));

            const { taxable, taxAmount, grandTotal } = calculateTaxAmount(
                rate,
                quantity,
                item.taxPercent,
                unit,
                actualRate
            );

            items[index] = {
                ...item,
                actualRate,
                rate,
                taxable,
                taxAmount,
                grandTotal,
            };

            return { ...prev, procurementItems: items };
        });
    };


    const renderAddPurchaseModal = () => (
        <Modal
            size="xl"
            show={showAddPurchaseModal}
            // onHide={() => setShowAddPurchaseModal(false)}
            onHide={handleCloseMainAddModal}
        >
            <Modal.Header closeButton>
                <Modal.Title>ADD NEW PURCHASE</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handlePurchaseSubmit}>
                    <Row className="g-3 mb-4">
                        <Col md={6} lg={3}>
                            <Form.Group controlId="vendorSelect">
                                <Form.Label className="fw-semibold">
                                    Vendor <span className="text-danger">*</span>
                                </Form.Label>
                                <Select
                                    options={vendors.map((vendor) => ({
                                        value: vendor._id,
                                        label: vendor.name,
                                    }))}
                                    value={
                                        inputData.vendor
                                            ? {
                                                value: inputData.vendor,
                                                label: vendors.find(
                                                    (vendor) => vendor._id === inputData.vendor,
                                                )?.name,
                                            }
                                            : null
                                    }
                                    onChange={(selectedOption) => {
                                        if (selectedOption) {
                                            handlePurchaseChange({
                                                target: { name: "vendor", value: selectedOption.value },
                                            });
                                        } else {
                                            handlePurchaseChange({
                                                target: { name: "vendor", value: "" },
                                            });
                                        }
                                    }}
                                    classNamePrefix="react-select"
                                    isClearable
                                    placeholder="Select Vendor"
                                />
                                {validationErrors.vendor && (
                                    <Form.Text className="text-danger">
                                        {validationErrors.vendor}
                                    </Form.Text>
                                )}
                            </Form.Group>
                        </Col>

                        <Col md={6} lg={3}>
                            <Form.Group controlId="idNumber">
                                <Form.Label className="fw-semibold">
                                    ID Number <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter ID Number"
                                    name="idNumber"
                                    value={inputData?.idNumber}
                                    onChange={handlePurchaseChange}
                                />
                                {validationErrors.idNumber && (
                                    <Form.Text className="text-danger">
                                        {validationErrors.idNumber}
                                    </Form.Text>
                                )}
                            </Form.Group>
                        </Col>

                        <Col md={6} lg={3}>
                            <Form.Group controlId="additionalCharges">
                                <Form.Label className="fw-semibold">
                                    Additional Charges <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    min={0}
                                    type="number"
                                    step="any"
                                    placeholder="0.00"
                                    name="additionalCharges"
                                    value={inputData.additionalCharges}
                                    onChange={handlePurchaseChange}
                                />
                                {validationErrors.additionalCharges && (
                                    <Form.Text className="text-danger">
                                        {validationErrors.additionalCharges}
                                    </Form.Text>
                                )}
                            </Form.Group>
                        </Col>

                        <Col md={6} lg={3}>
                            <Form.Group controlId="invoiceFile">
                                <Form.Label className="fw-semibold">Scanned Invoice</Form.Label>
                                <Form.Control
                                    type="file"
                                    onChange={handlePurchaseFileChange}
                                    accept=".txt, .png, .jpg, .jpeg, .pdf, .doc, .docx"
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="mb-0">Procurement Items</h5>
                        {/* <Button
              variant="outline-success"
              size="sm"
              onClick={handleAddItem}
            >
              <i className="bi bi-plus-lg me-1"></i> Add Item
            </Button> */}
                    </div>
                    <hr className="mb-4" />

                    {inputData.procurementItems.map((item, index) => (
                        <Card key={index} className="mb-3 border">
                            <Card.Body className="p-3">
                                <div className="text-end">
                                    <Button
                                        variant="outline-success"
                                        size="sm"
                                        onClick={handleAddItem}
                                    >
                                        <i className="bi bi-plus-lg me-1"></i> Add Item
                                    </Button>
                                </div>
                                <Row className="g-3">
                                    <Col md={4}>
                                        <Form.Group controlId={`material-${index}`}>
                                            <Form.Label className="fw-semibold d-flex justify-content-between">
                                                <span>Raw Materialsss<span className="text-danger">*</span></span>
                                                <Button
                                                    variant="link"
                                                    size="sm"
                                                    onClick={() => handleOpenNewMaterialModal()}
                                                    className="p-0 text-decoration-none"
                                                >
                                                    <i className="bi bi-plus-circle me-1"></i>
                                                    Add New
                                                </Button>
                                            </Form.Label>
                                            <Select
                                                options={rawMaterialList.map((rm) => ({
                                                    value: rm._id,
                                                    label: rm.name,
                                                }))}
                                                value={
                                                    item?.material
                                                        ? {
                                                            value: item.material,
                                                            label: rawMaterialList?.find(
                                                                (rm) => rm._id === item.material,
                                                            )?.name,
                                                        }
                                                        : null
                                                }
                                                onChange={async (selectedOption) => {
                                                    const materialId = selectedOption ? selectedOption.value : "";
                                                    // Update selected material first
                                                    handlePurchaseChange(
                                                        { target: { name: "material", value: materialId } },
                                                        index
                                                    );

                                                    if (materialId) {
                                                        try {
                                                            const headers = {
                                                                Authorization: `Bearer ${accessToken}`,
                                                            };
                                                            const response = await axios.get(`raw-material?_id=${materialId}`, { headers });

                                                            if (response?.data?.status === true) {
                                                                const raw = response?.data?.data?.rawMaterials;
                                                                const taxPercent = raw?.taxPercent || 0;
                                                                const unit = raw?.unit || "";

                                                                // ✅ Update the corresponding item fields
                                                                setInputData((prevData) => {
                                                                    const updatedItems = [...prevData.procurementItems];
                                                                    updatedItems[index] = {
                                                                        ...updatedItems[index],
                                                                        taxPercent,
                                                                        unit,
                                                                    };
                                                                    return { ...prevData, procurementItems: updatedItems };
                                                                });
                                                            }
                                                        } catch (error) {
                                                            console.error("Error fetching raw material details:", error);
                                                            toast.error("Failed to fetch raw material details");
                                                        }
                                                    } else {
                                                        // If cleared, reset those fields
                                                        setInputData((prevData) => {
                                                            const updatedItems = [...prevData.procurementItems];
                                                            updatedItems[index] = {
                                                                ...updatedItems[index],
                                                                taxPercent: 0,
                                                                unit: "",
                                                            };
                                                            return { ...prevData, procurementItems: updatedItems };
                                                        });
                                                    }
                                                }}
                                                classNamePrefix="react-select"
                                                isClearable
                                                placeholder="Select Material"
                                            />
                                            {validationErrors.procurementItems[index]?.material && (
                                                <Form.Text className="text-danger">
                                                    {validationErrors.procurementItems[index]?.material}
                                                </Form.Text>
                                            )}
                                        </Form.Group>
                                    </Col>

                                    <Col md={2}>
                                        <Form.Group controlId={`quantity-${index}`}>
                                            <Form.Label className="fw-semibold">
                                                Quantity <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                step="any"
                                                type="number"
                                                placeholder="0"
                                                name="quantity"
                                                value={item.quantity}
                                                onChange={(e) => handlePurchaseChange(e, index)}
                                            />
                                            {validationErrors.procurementItems[index]?.quantity && (
                                                <Form.Text className="text-danger">
                                                    {validationErrors.procurementItems[index]?.quantity}
                                                </Form.Text>
                                            )}
                                        </Form.Group>
                                    </Col>

                                    <Col md={1}>
                                        <Form.Group controlId={`unit-${index}`}>
                                            <Form.Label className="fw-semibold">Unit</Form.Label>
                                            <Form.Control
                                                disabled
                                                type="text"
                                                value={inputData.procurementItems[index]?.unit || ""}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={2}>
                                        <Form.Group controlId={`rate-${index}`}>
                                            <Form.Label className="fw-semibold">
                                                Actual Rate (₹) <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                step="any"
                                                // min={0}
                                                type="number"
                                                placeholder="0.00"
                                                name="actualRate"
                                                value={item.actualRate || ""}
                                                onChange={(e) => handleRateChange(e, index)}
                                            />
                                            {/* {validationErrors.procurementItems[index]?.rate && (
                                                <Form.Text className="text-danger">
                                                    {validationErrors.procurementItems[index]?.rate}
                                                </Form.Text>
                                            )} */}
                                        </Form.Group>
                                    </Col>

                                    <Col md={2}>
                                        <Form.Group controlId={`rate-${index}`}>
                                            <Form.Label className="fw-semibold">
                                                Rate (₹) <span className="text-danger">*</span>
                                            </Form.Label>
                                            {/* <Form.Control
                                                step="any"
                                                min={0}
                                                type="number"
                                                placeholder="0.00"
                                                name="rate"
                                                value={item.rate}
                                                onChange={(e) => handlePurchaseChange(e, index)}
                                            /> */}
                                            <Form.Control
                                                step="any"
                                                // min={0}
                                                type="number"
                                                placeholder="0.00"
                                                name="rate"
                                                value={item.rate}
                                                onChange={(e) => handlePurchaseChange(e, index)}
                                            />

                                            {validationErrors.procurementItems[index]?.rate && (
                                                <Form.Text className="text-danger">
                                                    {validationErrors.procurementItems[index]?.rate}
                                                </Form.Text>
                                            )}
                                        </Form.Group>
                                    </Col>

                                    <Col md={2} className="d-flex align-items-end">
                                        <div className="d-flex">
                                            {inputData.procurementItems.length > 1 && (
                                                <Button
                                                    variant="outline-danger"
                                                    size="sm"
                                                    onClick={() => handleRemoveItem(index)}
                                                    className="ms-2"
                                                    title="Remove Item"
                                                >
                                                    <i className="bi bi-dash-lg"></i>
                                                </Button>
                                            )}
                                        </div>
                                    </Col>
                                </Row>

                                <Row className="g-3 mt-2">
                                    <Col md={3}>
                                        <Form.Group controlId={`taxPercent-${index}`}>
                                            <Form.Label className="fw-semibold">
                                                Tax Percent
                                            </Form.Label>
                                            <Form.Control
                                                disabled
                                                type="text"
                                                value={`${inputData.procurementItems[index].taxPercent || "0"}%`}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={3}>
                                        <Form.Group controlId={`taxable-${index}`}>
                                            <Form.Label className="fw-semibold">
                                                Taxable Amount
                                            </Form.Label>
                                            <Form.Control
                                                disabled
                                                type="text"
                                                value={`₹${parseFloat(inputData.procurementItems[index].taxable || "0").toFixed(2)}`}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={3}>
                                        <Form.Group controlId={`taxAmount-${index}`}>
                                            <Form.Label className="fw-semibold">
                                                Tax Amount
                                            </Form.Label>
                                            <Form.Control
                                                disabled
                                                type="text"
                                                value={`₹${parseFloat(inputData.procurementItems[index].taxAmount || "0").toFixed(2)}`}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={3}>
                                        <Form.Group controlId={`grandTotal-${index}`}>
                                            <Form.Label className="fw-semibold">
                                                Grand Total
                                            </Form.Label>
                                            <Form.Control
                                                disabled
                                                type="text"
                                                value={`₹${parseFloat(inputData.procurementItems[index].grandTotal || "0").toFixed(2)}`}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    ))}

                    <div className="d-flex justify-content-end mt-4">
                        <Button
                            variant="primary"
                            type="submit"
                            disabled={purchaseBtnDisable() || isPurchaseLoading}
                            className="px-4"
                        >
                            {isPurchaseLoading ? (
                                <>
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    <span className="ms-2">Processing...</span>
                                </>
                            ) : (
                                "Submit Purchase"
                            )}
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div
                className={`main main-app p-3 p-lg-3 ${skin === "dark" ? "bg-dark text-white" : "bg-light"}`}
            >
                <Container fluid>
                    <div
                        className="container shadow-sm"
                        style={{ backgroundColor: "white" }}
                    >
                        <Row className="pt-4">
                            <Col>
                                <h5 className="fw-semibold">PURCHASE LIST</h5>
                            </Col>
                            <Col className="text-end" style={{ marginTop: "-15px" }}>
                                {(purchaseAccess.includes("PurchaseList:add") ||
                                    email === "contact@xpansecafe.com") && (
                                        <Button
                                            variant="success"
                                            onClick={() => setShowAddPurchaseModal(true)}
                                        >
                                            <i className="bi bi-plus-lg me-1"></i> Add Purchase
                                        </Button>
                                    )}
                            </Col>
                            <hr />
                        </Row>

                        <Row className="mb-3">
                            <Col md={3}>
                                <Form.Label className="fw-semibold text-secondary">
                                    Select Vendor
                                </Form.Label>
                                <Select
                                    options={vendors.map((vendor) => ({
                                        value: vendor._id,
                                        label: vendor.name,
                                    }))}
                                    value={
                                        selectedVendor
                                            ? {
                                                value: selectedVendor,
                                                label: vendors.find(
                                                    (vendor) => vendor._id === selectedVendor,
                                                )?.name,
                                            }
                                            : null
                                    }
                                    onChange={(selectedOption) => {
                                        if (selectedOption) {
                                            handleChange(selectedOption?.value);
                                        } else {
                                            handleChange("");
                                        }
                                    }}
                                    classNamePrefix="react-select"
                                    isClearable
                                    placeholder="Select Vendor"
                                />
                            </Col>
                            <Col md={2}>
                                <Form.Label className="fw-semibold text-secondary">
                                    Select Status
                                </Form.Label>
                                <Form.Select
                                    value={selectedStatus}
                                    onChange={(e) => setSelectedStatus(e.target.value)}
                                >
                                    <option value="">Select Status</option>
                                    <option value="RECEIVED">RECEIVED</option>
                                    <option value="PENDING">PENDING</option>
                                </Form.Select>
                            </Col>
                            <Col md={2}>
                                <Form.Label className="fw-semibold text-secondary">
                                    Sort By
                                </Form.Label>
                                <Form.Select
                                    value={selectedSortBy}
                                    onChange={(e) => setSelectedSortBy(e.target.value)}
                                >
                                    <option value="desc">DESCENDING</option>
                                    <option value="asc">ASCENDING</option>
                                </Form.Select>
                            </Col>
                            <Col md={2}>
                                <Form.Label className="fw-semibold text-secondary">
                                    Start Date <span className="text-danger">*</span>
                                </Form.Label>
                                <ReactDatePicker
                                    selected={startDate}
                                    dateFormat="dd-MM-yyyy"
                                    onChange={(date) => setStartDate(date)}
                                    placeholderText="Select Start Date"
                                    className="form-control"
                                />
                            </Col>
                            <Col md={2}>
                                <Form.Label className="fw-semibold text-secondary">
                                    End Date <span className="text-danger">*</span>
                                </Form.Label>
                                <ReactDatePicker
                                    selected={endDate}
                                    dateFormat="dd-MM-yyyy"
                                    onChange={handleEndDateChange}
                                    placeholderText="Select End Date"
                                    className="form-control"
                                />
                            </Col>
                            <Col md={1}>
                                <Form.Label className="text-white">.</Form.Label>
                                <Button
                                    variant="primary"
                                    className="w-100"
                                    onClick={handleSubmitFilters}
                                    disabled={btnLoading}
                                >
                                    {btnLoading ? (
                                        <Spinner size="sm" animation="border" />
                                    ) : (
                                        "Submit"
                                    )}
                                </Button>
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            {/* <Col md={3}>
                                <Form.Label className='fw-semibold text-secondary'>Search</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Search By ID Number"
                                    onChange={(e) => {setSearchText(e.target.value); setTouched(true)}}
                                />
                            </Col>
                            <Col md={3} className="text-center">
                                <Form.Label className="text-white">.</Form.Label>
                                <Button variant="primary" className="rounded-pill w-100" onClick={handleSubmitFilters} disabled={searchText === ""}>
                                    {searchBtnLoading ? <Spinner size="sm" animation="border" /> : "Search"}
                                </Button>
                            </Col> */}
                            <Col lg="5" className="mt-2">
                                <div className="input-group w-100">
                                    <input
                                        type="text"
                                        value={searchText}
                                        // onChange={handleSearchChange}
                                        onChange={(e) => {
                                            setSearchText(e.target.value);
                                            setTouched(true);
                                        }}
                                        className="form-control"
                                        placeholder="Search By ID Number..."
                                    />
                                    <button
                                        className="btn btn-primary w-25"
                                        type="button"
                                        onClick={handleSubmitFilters}
                                    >
                                        {searchBtnLoading ? (
                                            <Spinner size="sm" />
                                        ) : (
                                            <>
                                                {" "}
                                                <i className="ri-search-line"></i> Search{" "}
                                            </>
                                        )}
                                    </button>
                                </div>
                            </Col>
                        </Row>

                        {/* Procurement Listing Table */}
                        <Row>
                            <Col>
                                {(purchaseAccess.includes("PurchaseList:get") ||
                                    email === "contact@xpansecafe.com") && (
                                        <div className="table-responsive">
                                            <Table striped bordered hover className="mt-3">
                                                <thead className="table-dark">
                                                    <tr>
                                                        <th style={{ width: "70px" }}>#</th>
                                                        <th style={{ width: "160px" }}>FINANCIAL YEAR</th>
                                                        <th style={{ width: "110px" }}>DATE</th>
                                                        <th style={{ width: "120px" }}>ID NUMBER</th>
                                                        <th style={{ width: "200px" }}>VENDOR NAME</th>
                                                        <th style={{ width: "220px" }}>VENDOR CONTACT</th>
                                                        <th style={{ width: "100px" }}>STATUS</th>
                                                        <th>ACTIONS</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {filteredData.map((row, index) => (
                                                        <tr key={row.id || index}>
                                                            <td>{row.serialNumber || "--------"}</td>
                                                            <td>{row.financialYear || "--------"}</td>
                                                            <td>
                                                                {row.createdAt
                                                                    ? new Date(row.createdAt).toLocaleDateString()
                                                                    : "--------"}
                                                            </td>
                                                            <td>{row.idNumber || "--------"}</td>
                                                            <td>{row.vendor?.name || "--------"}</td>
                                                            <td>
                                                                <div>
                                                                    <a href="#" className="text-decoration-none">
                                                                        {row.vendor?.email || "--------"}
                                                                    </a>
                                                                    <br />
                                                                    <a href="#" className="text-decoration-none">
                                                                        {row.vendor?.phone || "--------"}
                                                                    </a>
                                                                </div>
                                                            </td>
                                                            <td
                                                                className={
                                                                    row.status === "PENDING"
                                                                        ? "text-danger"
                                                                        : "text-success"
                                                                }
                                                            >
                                                                {row.status || "--------"}
                                                            </td>
                                                            <td className="text-center">
                                                                <Dropdown>
                                                                    <Dropdown.Toggle
                                                                        variant="outline-secondary"
                                                                        size="sm"
                                                                        id="dropdown-actions"
                                                                        className="rounded-pill px-3"
                                                                    >
                                                                        <i className="bi bi-gear-fill me-1"></i>{" "}
                                                                        Actions
                                                                    </Dropdown.Toggle>

                                                                    <Dropdown.Menu className="shadow-sm border-0">
                                                                        {/* Always visible actions */}
                                                                        <Dropdown.Item
                                                                            onClick={() => handleOpenViewModal(row)}
                                                                            className="d-flex align-items-center"
                                                                        >
                                                                            <i className="bi bi-eye me-2 text-primary"></i>
                                                                            <span>View Details</span>
                                                                        </Dropdown.Item>

                                                                        {/* Status-dependent actions */}
                                                                        {row.status === "PENDING" && (
                                                                            <>
                                                                                <Dropdown.Divider />
                                                                                {(purchaseAccess.includes(
                                                                                    "PurchaseList:update",
                                                                                ) ||
                                                                                    email === "contact@xpansecafe.com") && (
                                                                                        <Dropdown.Item
                                                                                            onClick={() =>
                                                                                                handleOpenUpdateStatusModal(row)
                                                                                            }
                                                                                            className="d-flex align-items-center"
                                                                                        >
                                                                                            <i className="bi bi-pencil-square me-2 text-warning"></i>
                                                                                            <span>Update Status</span>
                                                                                        </Dropdown.Item>
                                                                                    )}
                                                                                {(purchaseAccess.includes(
                                                                                    "PurchaseList:delete",
                                                                                ) ||
                                                                                    email === "contact@xpansecafe.com") && (
                                                                                        <Dropdown.Item
                                                                                            onClick={() => handleDeleteModal(row)}
                                                                                            className="d-flex align-items-center text-danger"
                                                                                        >
                                                                                            <i className="bi bi-trash3 me-2"></i>
                                                                                            <span>Delete</span>
                                                                                        </Dropdown.Item>
                                                                                    )}
                                                                            </>
                                                                        )}
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>

                                            {/* Pagination */}
                                            {filteredData.length > 0 && (
                                                <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3 mb-4">
                                                    <div className="text-muted small">
                                                        Showing{" "}
                                                        <span className="fw-semibold">
                                                            {(currentPage - 1) * recordsPerPage + 1}
                                                        </span>{" "}
                                                        to{" "}
                                                        <span className="fw-semibold">
                                                            {Math.min(
                                                                currentPage * recordsPerPage,
                                                                totalRecords,
                                                            )}
                                                        </span>{" "}
                                                        of <span className="fw-semibold">{totalRecords}</span>{" "}
                                                        entries
                                                    </div>

                                                    <div className="d-flex align-items-center gap-3">
                                                        <Form.Group className="d-flex align-items-center">
                                                            <Form.Label className="fw-semibold">
                                                                Records Per Page :
                                                            </Form.Label>
                                                            <Form.Select
                                                                style={{ width: "80px" }}
                                                                size="sm"
                                                                value={recordsPerPage}
                                                                onChange={(e) =>
                                                                    handlerecordsPerPageChange(
                                                                        Number(e.target.value),
                                                                    )
                                                                }
                                                                className="ms-2"
                                                            >
                                                                <option value={10}>10</option>
                                                                <option value={20}>20</option>
                                                                <option value={50}>50</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                        <div className="d-flex align-items-center gap-1">
                                                            <Button
                                                                variant="outline-secondary"
                                                                size="sm"
                                                                onClick={() =>
                                                                    handlePageChange(Math.max(currentPage - 1, 1))
                                                                }
                                                                disabled={currentPage === 1}
                                                                className="px-3"
                                                            >
                                                                <i className="bi bi-chevron-left"></i>
                                                            </Button>

                                                            <div className="mx-2 text-nowrap">
                                                                Page{" "}
                                                                <span className="fw-bold">{currentPage}</span> of{" "}
                                                                <span className="fw-bold">
                                                                    {Math.ceil(totalRecords / recordsPerPage)}
                                                                </span>
                                                            </div>

                                                            <Button
                                                                variant="outline-secondary"
                                                                size="sm"
                                                                onClick={() =>
                                                                    handlePageChange(
                                                                        Math.min(
                                                                            currentPage + 1,
                                                                            Math.ceil(totalRecords / recordsPerPage),
                                                                        ),
                                                                    )
                                                                }
                                                                disabled={
                                                                    currentPage * recordsPerPage >= totalRecords
                                                                }
                                                                className="px-3"
                                                            >
                                                                <i className="bi bi-chevron-right"></i>
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}
                            </Col>
                        </Row>

                        {openViewModal ? (
                            <Modal
                                size="lg"
                                show={openViewModal}
                                onHide={() => setOpenViewModal(false)}
                                centered
                                aria-labelledby="vertically-centered-modal"
                            >
                                <Modal.Header
                                    style={{ backgroundColor: "#f2f2f2" }}
                                    closeButton
                                >
                                    <Modal.Title style={{ marginLeft: "240px" }}>
                                        <h5 className="fw-semibold">VIEW PROCUREMENT DETAILS</h5>
                                    </Modal.Title>
                                </Modal.Header>

                                <Modal.Body>
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th
                                                    colSpan="6"
                                                    className="text-center fw-semibold"
                                                    style={{ borderBottom: "1.5px solid #000" }}
                                                >
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <span style={{ flex: "1" }}>
                                                            PROCUREMENT DETAILS
                                                        </span>
                                                        {singleProcurementDetails.status === "PENDING" && (
                                                            <Dropdown className="cursor-pointer">
                                                                <Dropdown.Toggle
                                                                    variant="secondary"
                                                                    size="sm"
                                                                    id="dropdown-action"
                                                                >
                                                                    Action
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu>
                                                                    {(purchaseAccess?.includes(
                                                                        "PurchaseList:update",
                                                                    ) ||
                                                                        email === "contact@xpansecafe.com") && (
                                                                            <Dropdown.Item
                                                                                style={{ cursor: "pointer" }}
                                                                                onClick={() =>
                                                                                    handleEditModal(
                                                                                        singleProcurementDetails,
                                                                                    )
                                                                                }
                                                                            >
                                                                                Edit Procurement
                                                                            </Dropdown.Item>
                                                                        )}
                                                                    {(purchaseAccess?.includes(
                                                                        "PurchaseList:update",
                                                                    ) ||
                                                                        email === "contact@xpansecafe.com") && (
                                                                            <Dropdown.Item
                                                                                style={{ cursor: "pointer" }}
                                                                                onClick={() =>
                                                                                    handleOpenEditStatusWithRemarksModal(
                                                                                        singleProcurementDetails,
                                                                                    )
                                                                                }
                                                                            >
                                                                                Update Procurement Status with Remarks
                                                                            </Dropdown.Item>
                                                                        )}
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        )}
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td colSpan="3" valign="top" width="50%">
                                                    <table
                                                        className="table table-striped table-condensed"
                                                        style={{
                                                            width: "100%",
                                                            borderCollapse: "collapse",
                                                            marginTop: "10px",
                                                        }}
                                                    >
                                                        <thead>
                                                            <tr>
                                                                <th
                                                                    colSpan="2"
                                                                    className="text-center fw-semibold"
                                                                    style={{
                                                                        borderBottom: "1px solid #000",
                                                                        fontSize: "14px",
                                                                    }}
                                                                >
                                                                    PROCUREMENT DETAILS
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody style={{ fontSize: "13px" }}>
                                                            <tr>
                                                                <th
                                                                    className="w-50 fw-semibold"
                                                                    style={{
                                                                        borderBottom: "1px solid #000",
                                                                        padding: "8px",
                                                                    }}
                                                                >
                                                                    ID Number
                                                                </th>
                                                                <td
                                                                    className="fw-semibold"
                                                                    style={{
                                                                        borderBottom: "1px solid #000",
                                                                        padding: "8px",
                                                                    }}
                                                                >
                                                                    {singleProcurementDetails?.idNumber}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th
                                                                    className="fw-semibold"
                                                                    style={{
                                                                        borderBottom: "1px solid #000",
                                                                        padding: "8px",
                                                                    }}
                                                                >
                                                                    Serial Number
                                                                </th>
                                                                <td
                                                                    className="fw-semibold"
                                                                    style={{
                                                                        borderBottom: "1px solid #000",
                                                                        padding: "8px",
                                                                    }}
                                                                >
                                                                    {singleProcurementDetails?.serialNo}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th
                                                                    className="fw-semibold"
                                                                    style={{
                                                                        borderBottom: "1px solid #000",
                                                                        padding: "8px",
                                                                    }}
                                                                >
                                                                    Financial Year
                                                                </th>
                                                                <td
                                                                    style={{
                                                                        borderBottom: "1px solid #000",
                                                                        padding: "8px",
                                                                    }}
                                                                >
                                                                    {singleProcurementDetails?.financialYear}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th
                                                                    className="fw-semibold"
                                                                    style={{
                                                                        borderBottom: "1px solid #000",
                                                                        padding: "8px",
                                                                    }}
                                                                >
                                                                    Status
                                                                </th>
                                                                <td
                                                                    style={{
                                                                        borderBottom: "1px solid #000",
                                                                        padding: "8px",
                                                                    }}
                                                                >
                                                                    {singleProcurementDetails?.status}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th
                                                                    className="fw-semibold"
                                                                    style={{
                                                                        borderBottom: "1px solid #000",
                                                                        padding: "8px",
                                                                    }}
                                                                >
                                                                    Additional Chargers
                                                                </th>
                                                                <td
                                                                    style={{
                                                                        borderBottom: "1px solid #000",
                                                                        padding: "8px",
                                                                    }}
                                                                >
                                                                    ₹{" "}
                                                                    {singleProcurementDetails?.additionalCharges}
                                                                </td>
                                                            </tr>
                                                            {/* ... other procurement detail rows ... */}
                                                        </tbody>
                                                    </table>
                                                </td>

                                                <td colSpan="3" valign="top">
                                                    <table
                                                        className="table table-striped table-condensed"
                                                        style={{
                                                            width: "100%",
                                                            borderCollapse: "collapse",
                                                            marginTop: "10px",
                                                        }}
                                                    >
                                                        <thead>
                                                            <tr>
                                                                <th
                                                                    colSpan="2"
                                                                    className="text-center fw-semibold"
                                                                    style={{
                                                                        borderBottom: "1px solid #000",
                                                                        fontSize: "14px",
                                                                    }}
                                                                >
                                                                    VENDOR DETAILS
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody style={{ fontSize: "13px" }}>
                                                            <tr>
                                                                <th
                                                                    className="fw-semibold"
                                                                    style={{
                                                                        borderBottom: "1px solid #000",
                                                                        padding: "8px",
                                                                    }}
                                                                >
                                                                    GST
                                                                </th>
                                                                <th
                                                                    className="fw-semibold"
                                                                    style={{
                                                                        borderBottom: "1px solid #000",
                                                                        padding: "8px",
                                                                    }}
                                                                >
                                                                    {singleProcurementDetails?.vendor?.gstin}
                                                                </th>
                                                            </tr>
                                                            <tr>
                                                                <th
                                                                    className="fw-semibold"
                                                                    style={{
                                                                        borderBottom: "1px solid #000",
                                                                        padding: "8px",
                                                                    }}
                                                                >
                                                                    Name
                                                                </th>
                                                                <td
                                                                    style={{
                                                                        borderBottom: "1px solid #000",
                                                                        padding: "8px",
                                                                    }}
                                                                >
                                                                    {singleProcurementDetails?.vendor?.name}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th
                                                                    className="fw-semibold"
                                                                    style={{
                                                                        borderBottom: "1px solid #000",
                                                                        padding: "8px",
                                                                    }}
                                                                >
                                                                    Email
                                                                </th>
                                                                <td
                                                                    style={{
                                                                        borderBottom: "1px solid #000",
                                                                        padding: "8px",
                                                                    }}
                                                                >
                                                                    {singleProcurementDetails?.vendor?.email}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th
                                                                    className="fw-semibold"
                                                                    style={{
                                                                        borderBottom: "1px solid #000",
                                                                        padding: "8px",
                                                                    }}
                                                                >
                                                                    Phone
                                                                </th>
                                                                <td
                                                                    style={{
                                                                        borderBottom: "1px solid #000",
                                                                        padding: "8px",
                                                                    }}
                                                                >
                                                                    {singleProcurementDetails?.vendor?.phone}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th
                                                                    className="fw-semibold"
                                                                    style={{
                                                                        borderBottom: "1px solid #000",
                                                                        padding: "8px",
                                                                    }}
                                                                >
                                                                    Address
                                                                </th>
                                                                <td
                                                                    style={{
                                                                        borderBottom: "1px solid #000",
                                                                        padding: "8px",
                                                                    }}
                                                                >
                                                                    {singleProcurementDetails?.vendor?.address}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th
                                                                    className="fw-semibold"
                                                                    style={{
                                                                        borderBottom: "1px solid #000",
                                                                        padding: "8px",
                                                                    }}
                                                                >
                                                                    Pincode
                                                                </th>
                                                                <td
                                                                    style={{
                                                                        borderBottom: "1px solid #000",
                                                                        padding: "8px",
                                                                    }}
                                                                >
                                                                    {singleProcurementDetails?.vendor?.pincode}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th
                                                                    className="fw-semibold"
                                                                    style={{
                                                                        borderBottom: "1px solid #000",
                                                                        padding: "8px",
                                                                    }}
                                                                >
                                                                    City
                                                                </th>
                                                                <td
                                                                    style={{
                                                                        borderBottom: "1px solid #000",
                                                                        padding: "8px",
                                                                    }}
                                                                >
                                                                    {singleProcurementDetails?.vendor?.city}
                                                                    {singleProcurementDetails?.vendor?.state}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th
                                                                    className="fw-semibold"
                                                                    style={{
                                                                        borderBottom: "1px solid #000",
                                                                        padding: "8px",
                                                                    }}
                                                                >
                                                                    {" "}
                                                                    State
                                                                </th>
                                                                <td
                                                                    style={{
                                                                        borderBottom: "1px solid #000",
                                                                        padding: "8px",
                                                                    }}
                                                                >
                                                                    {singleProcurementDetails?.vendor?.state}
                                                                </td>
                                                            </tr>
                                                            {/* ... other vendor detail rows ... */}
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <Table striped bordered className="mt-4">
                                        <thead>
                                            <tr>
                                                <th
                                                    className="fs-6 fw-semibold pt-2 pb-2 text-center"
                                                    colSpan="9"
                                                >
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <span style={{ flex: "1" }}>PROCUREMENT ITEMS</span>

                                                        {singleProcurementDetails?.status === "PENDING" && (
                                                            <>
                                                                {(purchaseAccess.includes("PurchaseList:add") ||
                                                                    email === "contact@xpansecafe.com") && (
                                                                        <Button
                                                                            variant="warning"
                                                                            style={{ borderRadius: "18px" }}
                                                                            onClick={() =>
                                                                                handleOpenAddProcurementItemModal(
                                                                                    singleProcurementDetails,
                                                                                )
                                                                            }
                                                                        >
                                                                            Add Item
                                                                        </Button>
                                                                    )}
                                                            </>
                                                        )}
                                                    </div>
                                                </th>
                                            </tr>

                                            <tr>
                                                <th
                                                    className="text-center fw-bold"
                                                    style={{ fontSize: "12px" }}
                                                >
                                                    #
                                                </th>
                                                <th
                                                    className="text-center fw-bold"
                                                    style={{ fontSize: "12px" }}
                                                >
                                                    MATERIAL NAME
                                                </th>
                                                <th
                                                    className="text-center fw-bold"
                                                    style={{ fontSize: "12px" }}
                                                >
                                                    QTY
                                                </th>
                                                <th
                                                    className="text-center fw-bold"
                                                    style={{ fontSize: "12px" }}
                                                >
                                                    RATE
                                                </th>
                                                <th
                                                    className="text-end fw-bold"
                                                    style={{ fontSize: "12px" }}
                                                >
                                                    TAXABLE
                                                </th>
                                                <th
                                                    className="text-end fw-bold"
                                                    style={{ fontSize: "12px" }}
                                                >
                                                    TAX AMOUNT
                                                </th>
                                                <th
                                                    className="text-end fw-bold"
                                                    style={{ width: "100px", fontSize: "12px" }}
                                                >
                                                    GRAND TOTAL
                                                </th>
                                                <th
                                                    className="text-end fw-bold"
                                                    style={{ fontSize: "12px" }}
                                                >
                                                    STATUS
                                                </th>
                                                <th
                                                    className="text-end fw-bold"
                                                    style={{ fontSize: "12px" }}
                                                >
                                                    ACTIONS
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {singleProcurementItemsDetails?.map((item, index) => (
                                                <tr key={item._id}>
                                                    <td
                                                        className="text-center"
                                                        style={{ fontSize: "13px" }}
                                                    >
                                                        {index + 1}
                                                    </td>
                                                    <td
                                                        className="text-center"
                                                        style={{ fontSize: "13px" }}
                                                    >
                                                        {item?.material?.name}
                                                    </td>
                                                    <td
                                                        className="text-center"
                                                        style={{ fontSize: "13px" }}
                                                    >
                                                        {item?.quantity?.toFixed(3)}
                                                    </td>
                                                    <td
                                                        className="text-center"
                                                        style={{ fontSize: "13px" }}
                                                    >
                                                        {item?.rate?.toFixed(2)}
                                                    </td>
                                                    <td className="text-end" style={{ fontSize: "13px" }}>
                                                        {(item?.rate * item?.quantity).toFixed(2)}
                                                    </td>
                                                    <td className="text-end" style={{ fontSize: "13px" }}>
                                                        {(
                                                            item?.rate *
                                                            item?.quantity *
                                                            (item?.material?.taxPercent / 100)
                                                        ).toFixed(2)}
                                                    </td>
                                                    <td className="text-end" style={{ fontSize: "13px" }}>
                                                        {(
                                                            item?.rate * item?.quantity +
                                                            item?.rate *
                                                            item?.quantity *
                                                            (item?.material?.taxPercent / 100)
                                                        ).toFixed(2)}
                                                    </td>
                                                    <td
                                                        className="text-center"
                                                        style={{ fontSize: "13px", cursor: "pointer" }}
                                                    >
                                                        {item?.status}
                                                    </td>
                                                    <td className="text-center">
                                                        <Dropdown className="cursor-pointer">
                                                            <div
                                                                style={{
                                                                    display: "inline-block",
                                                                    position: "relative",
                                                                }}
                                                            >
                                                                {item.status !== "PENDING" ? (
                                                                    <OverlayTrigger
                                                                        placement="top"
                                                                        overlay={
                                                                            <Tooltip>
                                                                                No actions can be performed
                                                                            </Tooltip>
                                                                        }
                                                                    >
                                                                        <span
                                                                            style={{
                                                                                display: "inline-block",
                                                                                cursor: "not-allowed",
                                                                            }}
                                                                        >
                                                                            <Dropdown.Toggle
                                                                                variant="secondary"
                                                                                size="sm"
                                                                                disabled
                                                                            >
                                                                                Action
                                                                            </Dropdown.Toggle>
                                                                        </span>
                                                                    </OverlayTrigger>
                                                                ) : (
                                                                    <Dropdown.Toggle
                                                                        variant="secondary"
                                                                        size="sm"
                                                                    >
                                                                        Action
                                                                    </Dropdown.Toggle>
                                                                )}
                                                            </div>
                                                            <Dropdown.Menu>
                                                                {item.status === "PENDING" && (
                                                                    <>
                                                                        {(purchaseAccess.includes(
                                                                            "PurchaseList:udpate",
                                                                        ) ||
                                                                            email === "contact@xpansecafe.com") && (
                                                                                <Dropdown.Item
                                                                                    onClick={() =>
                                                                                        handleOpenProcurementItemEditModal(
                                                                                            item,
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    Edit
                                                                                </Dropdown.Item>
                                                                            )}
                                                                        {(purchaseAccess.includes(
                                                                            "PurchaseList:delete",
                                                                        ) ||
                                                                            email === "contact@xpansecafe.com") && (
                                                                                <Dropdown.Item
                                                                                    onClick={() =>
                                                                                        handleOpenProcurementItemDeleteModal(
                                                                                            item,
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    Delete
                                                                                </Dropdown.Item>
                                                                            )}
                                                                        {(purchaseAccess.includes(
                                                                            "PurchaseList:update",
                                                                        ) ||
                                                                            email === "contact@xpansecafe.com") && (
                                                                                <Dropdown.Item
                                                                                    onClick={() =>
                                                                                        handleOpenProcurementItemUpdateStatus(
                                                                                            item,
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    Update Status
                                                                                </Dropdown.Item>
                                                                            )}
                                                                    </>
                                                                )}
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colSpan="6" className="text-end">
                                                    <span style={{ fontWeight: "550", fontSize: "14px" }}>
                                                        <p style={{ fontSize: "13px" }}> Taxable</p>
                                                        <p style={{ fontSize: "13px" }}>+ Tax Amount</p>
                                                        <p style={{ fontSize: "10px" }}>
                                                            (+ Additional Charges)
                                                        </p>
                                                        <i
                                                            style={{
                                                                borderTop: "1px solid #000",
                                                                padding: "8px",
                                                            }}
                                                        >
                                                            = Grand Total
                                                        </i>
                                                    </span>
                                                </td>

                                                <td className="text-end">
                                                    <p style={{ fontSize: "13px", fontWeight: "600" }}>
                                                        {totals.totalTaxable.toFixed(2)}
                                                    </p>
                                                    <p style={{ fontSize: "13px", fontWeight: "600" }}>
                                                        + {totals.totalTaxAmount.toFixed(2)}
                                                    </p>
                                                    <p style={{ fontSize: "11px", fontWeight: "400" }}>
                                                        (+ {totals.totalAdditionalCharges.toFixed(2)})
                                                    </p>
                                                    <p
                                                        style={{
                                                            borderTop: "1px solid #000",
                                                            fontSize: "14px",
                                                            fontWeight: "600",
                                                        }}
                                                    >
                                                        = {totals.totalGrandTotal.toFixed(2)}
                                                    </p>
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </Table>
                                </Modal.Body>
                                <Modal.Footer>
                                    <a href={singleProcurementDetails?.scannedInvoice}>
                                        <Button variant="primary">Download Invoice</Button>
                                    </a>

                                    <Button
                                        variant="warning"
                                        onClick={() => setOpenViewModal(false)}
                                    >
                                        Close
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                        ) : null}

                        {openEditModal && (
                            <Modal
                                centered
                                show={openEditModal}
                                onHide={() => setOpenEditModal(false)}
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title className="fs-6">
                                        EDIT PROCUREMENT DETAILS
                                    </Modal.Title>
                                </Modal.Header>
                                <Form onSubmit={handleEditSubmit}>
                                    <Modal.Body>
                                        <Row>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold">
                                                        Select Vendor <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Select
                                                        size="sm"
                                                        onChange={handleEditChange}
                                                        value={editedData.vendor}
                                                        name="vendor"
                                                        className="mb-3"
                                                    >
                                                        <option>Select Vendor</option>
                                                        {vendors &&
                                                            vendors.map((rm) => (
                                                                <option key={rm._id} value={rm._id}>
                                                                    {rm.name}
                                                                </option>
                                                            ))}
                                                    </Form.Select>
                                                    <div className="text-danger">
                                                        {editValidationErrors.vendor}
                                                    </div>
                                                </Form.Group>
                                            </Col>

                                            <Col md={5}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        ID Number <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="ID Number"
                                                        name="idNumber"
                                                        value={editedData.idNumber}
                                                        onChange={handleIdNumberChange}
                                                    />
                                                    <div className="text-danger">
                                                        {editValidationErrors.idNumber}
                                                    </div>
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Scanned Invoice
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="file"
                                                        onChange={handleFileChange}
                                                    />
                                                    <div className="text-danger">
                                                        {editValidationErrors.scannedInvoice}
                                                    </div>
                                                </Form.Group>
                                            </Col>

                                            <Col md={5}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Additional Charges{" "}
                                                        <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        min={0}
                                                        step="any"
                                                        placeholder="Additional Charges"
                                                        name="additionalCharges"
                                                        value={editedData.additionalCharges}
                                                        onChange={handleEditChange}
                                                        className="no-arrows"
                                                    />
                                                    <div className="text-danger">
                                                        {editValidationErrors.additionalCharges}
                                                    </div>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button
                                            type="submit"
                                            variant="primary"
                                            disabled={isEditBtnLoading}
                                        >
                                            {isEditBtnLoading ? (
                                                <Spinner size="sm" animation="border" />
                                            ) : (
                                                "SAVE CHANGES"
                                            )}
                                        </Button>
                                    </Modal.Footer>
                                </Form>
                            </Modal>
                        )}

                        {openDeleteModal && (
                            <Modal
                                centered
                                show={openDeleteModal}
                                onHide={() => setOpenDeleteModal(false)}
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title className="fs-6">DELETE PROCUREMENT</Modal.Title>
                                </Modal.Header>
                                <Form onSubmit={handleDeleteProcurement}>
                                    <Modal.Body>
                                        Are you sure you want to delete this procurement?
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button
                                            variant="warning"
                                            onClick={() => setOpenDeleteModal(false)}
                                            style={{ borderRadius: "18px" }}
                                        >
                                            Close
                                        </Button>
                                        <Button
                                            type="submit"
                                            variant="danger"
                                            disabled={isDeleteBtnLoading}
                                        >
                                            {isDeleteBtnLoading ? (
                                                <Spinner size="sm" animation="border" />
                                            ) : (
                                                "CONFIRM"
                                            )}
                                        </Button>
                                    </Modal.Footer>
                                </Form>
                            </Modal>
                        )}

                        {openUpdateStatusModal ? (
                            <Modal
                                show={openUpdateStatusModal}
                                onHide={() => {
                                    resetModalFields();
                                    setOpenUpdateStatusModal(false);
                                }}
                                centered
                                aria-labelledby="vertically-centered-modal"
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title id="vertically-centered-modal" className="fs-6">
                                        UPDATE STATUS OF THE PROCUREMENT
                                    </Modal.Title>
                                </Modal.Header>
                                <Form onSubmit={handleProcurementUpdateStatus}>
                                    <Modal.Body>
                                        <p className="fw-semibold text-muted">
                                            Are you sure you want to update the status of this
                                            procurement?
                                        </p>
                                        <span className="text-success fw-semibold mt-1">
                                            Please select a storage location before confirming.
                                        </span>

                                        {/* Select Storage Location Field */}
                                        <Col md={12} className="mt-1">
                                            <Form.Label className="fw-semibold text-muted">
                                                Select Storage Location{" "}
                                                <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Select
                                                components={animatedComponents}
                                                id="selectField"
                                                name="storage_location"
                                                value={storageLocationList
                                                    .map((storage) => ({
                                                        value: storage?._id,
                                                        label: `${storage?.name} -> ${storage?.city}, ${storage?.state}`,
                                                    }))
                                                    .find(
                                                        (option) =>
                                                            option.value === selectedStorageLocation,
                                                    )}
                                                onChange={(selectedOption) =>
                                                    setSelectedStorageLocation(
                                                        selectedOption ? selectedOption.value : "",
                                                    )
                                                }
                                                options={storageLocationList.map((storage) => ({
                                                    value: storage?._id,
                                                    label: `${storage?.name} -> ${storage?.city}, ${storage?.state}`,
                                                }))}
                                                placeholder="Select a Storage Location"
                                                isClearable
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        borderColor: selectedStorageLocation
                                                            ? base.borderColor
                                                            : "red",
                                                    }),
                                                }}
                                            />
                                            {!selectedStorageLocation && (
                                                <span
                                                    className="text-danger d-block"
                                                    style={{ fontSize: "13px" }}
                                                >
                                                    Storage location is required.
                                                </span>
                                            )}
                                        </Col>
                                    </Modal.Body>

                                    <Modal.Footer>
                                        <Button
                                            variant="warning"
                                            onClick={() => setOpenUpdateStatusModal(false)}
                                            style={{
                                                borderRadius: "18px",
                                            }}
                                        >
                                            Close
                                        </Button>
                                        <Button type="submit">
                                            {isStatusBtnLoading ? <Spinner /> : "CONFIRM"}
                                        </Button>
                                    </Modal.Footer>
                                </Form>
                            </Modal>
                        ) : null}

                        {openAddProcurementItemModal ? (
                            <Modal
                                size="lg"
                                show={openAddProcurementItemModal}
                                onHide={handleCloseAddProcurementItemModal}
                                centered
                                aria-labelledby="vertically-centered-modal"
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title id="vertically-centered-modal" className="fs-6">
                                        ADD NEW PROCUREMENT ITEM
                                    </Modal.Title>
                                </Modal.Header>
                                <Form onSubmit={addProcurementItem}>
                                    <Modal.Body>
                                        <Row>
                                            <Col>
                                                <div className="mb-3">
                                                    <Form.Label>
                                                        Select Material <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Select
                                                        size="sm"
                                                        name="material"
                                                        className="mb-3"
                                                        options={rawMaterialOptions}
                                                        value={
                                                            rawMaterialOptions.find(
                                                                (rm) =>
                                                                    rm.value ===
                                                                    addProcurementItemDetails.material,
                                                            ) || null
                                                        }
                                                        onChange={async (selectedOption) => {
                                                            const materialId = selectedOption?.value || "";

                                                            // Update selected material
                                                            handleAddProcurementItemChanges(
                                                                "material",
                                                                materialId
                                                            );

                                                            if (materialId) {
                                                                try {
                                                                    const headers = {
                                                                        Authorization: `Bearer ${accessToken}`,
                                                                    };
                                                                    const response = await axios.get(
                                                                        `raw-material?_id=${materialId}`,
                                                                        { headers },
                                                                    );

                                                                    if (response?.data?.status === true) {
                                                                        const raw = response?.data?.data?.rawMaterials;
                                                                        const taxPercent = raw?.taxPercent || 0;
                                                                        const unit = raw?.unit || "";

                                                                        // Update the item fields
                                                                        setAddProcurementItemDetails(prev => ({
                                                                            ...prev,
                                                                            taxPercent,
                                                                            unit,
                                                                        }));
                                                                    }
                                                                } catch (error) {
                                                                    console.error(
                                                                        "Error fetching raw material details:",
                                                                        error,
                                                                    );
                                                                    toast.error(
                                                                        "Failed to fetch raw material details",
                                                                    );
                                                                }
                                                            } else {
                                                                // If cleared, reset those fields
                                                                setAddProcurementItemDetails(prev => ({
                                                                    ...prev,
                                                                    taxPercent: 0,
                                                                    unit: "",
                                                                }));
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </Col>
                                            <Col>
                                                <div className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Quantity <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        min={0}
                                                        step="any"
                                                        type="number"
                                                        placeholder="Quantity"
                                                        className="no-arrows"
                                                        name="quantity"
                                                        value={addProcurementItemDetails.quantity}
                                                        onChange={(e) => {
                                                            handleAddProcurementItemChanges(e);

                                                            // Recalculate when quantity changes
                                                            const { rate, quantity, taxPercent, unit, actualRate } = addProcurementItemDetails;
                                                            const qty = parseFloat(e.target.value) || 0;
                                                            const actRate = parseFloat(actualRate) || 0;

                                                            if (unit === "GRAMS" || unit === "ML") {
                                                                // Calculate rate based on actualRate and quantity
                                                                const calculatedRate = actRate > 0 && qty > 0
                                                                    ? actRate / qty
                                                                    : 0;

                                                                const { taxable, taxAmount, grandTotal } = calculateTaxAmount(
                                                                    calculatedRate,
                                                                    qty,
                                                                    taxPercent,
                                                                    unit,
                                                                    actRate
                                                                );

                                                                setAddProcurementItemDetails(prev => ({
                                                                    ...prev,
                                                                    quantity: qty,
                                                                    rate: Number(calculatedRate.toFixed(5)),
                                                                    taxable,
                                                                    taxAmount,
                                                                    grandTotal
                                                                }));
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </Col>
                                            <Col>
                                                <div className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Unit <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Unit"
                                                        className="no-arrows"
                                                        name="unit"
                                                        value={addProcurementItemDetails.unit}
                                                        disabled
                                                    />
                                                </div>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col>
                                                <div className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Actual Rate (₹) <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        step="any"
                                                        type="number"
                                                        placeholder="0.00"
                                                        name="actualRate"
                                                        value={addProcurementItemDetails.actualRate || ""}
                                                        onChange={(e) => {
                                                            const actualRate = parseFloat(e.target.value) || 0;
                                                            const quantity = parseFloat(addProcurementItemDetails.quantity) || 0;
                                                            const unit = addProcurementItemDetails.unit;
                                                            const taxPercent = addProcurementItemDetails.taxPercent || 0;

                                                            let rate = actualRate;

                                                            // Calculate rate based on unit
                                                            if ((unit === "GRAMS" || unit === "ML") && actualRate > 0 && quantity > 0) {
                                                                rate = actualRate / quantity;
                                                            }

                                                            rate = Number(rate.toFixed(5));

                                                            const { taxable, taxAmount, grandTotal } = calculateTaxAmount(
                                                                rate,
                                                                quantity,
                                                                taxPercent,
                                                                unit,
                                                                actualRate
                                                            );

                                                            setAddProcurementItemDetails(prev => ({
                                                                ...prev,
                                                                actualRate,
                                                                rate,
                                                                taxable,
                                                                taxAmount,
                                                                grandTotal
                                                            }));
                                                        }}
                                                    />
                                                </div>
                                            </Col>
                                            <Col>
                                                <div className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Rate (₹) <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        step="any"
                                                        type="number"
                                                        placeholder="0.00"
                                                        name="rate"
                                                        value={addProcurementItemDetails.rate || ""}
                                                        onChange={(e) => {
                                                            const rate = parseFloat(e.target.value) || 0;
                                                            const quantity = parseFloat(addProcurementItemDetails.quantity) || 0;
                                                            const unit = addProcurementItemDetails.unit;
                                                            const taxPercent = addProcurementItemDetails.taxPercent || 0;

                                                            let actualRate = rate;

                                                            // Calculate actualRate based on unit
                                                            if (unit === "GRAMS" || unit === "ML") {
                                                                actualRate = rate * quantity;
                                                            }

                                                            const { taxable, taxAmount, grandTotal } = calculateTaxAmount(
                                                                rate,
                                                                quantity,
                                                                taxPercent,
                                                                unit,
                                                                actualRate
                                                            );

                                                            setAddProcurementItemDetails(prev => ({
                                                                ...prev,
                                                                rate,
                                                                actualRate: Number(actualRate.toFixed(2)),
                                                                taxable,
                                                                taxAmount,
                                                                grandTotal
                                                            }));
                                                        }}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col>
                                                <div className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Tax Percent
                                                    </Form.Label>
                                                    <Form.Control
                                                        min={0}
                                                        type="number"
                                                        step="any"
                                                        placeholder="Tax Percent"
                                                        className="no-arrows"
                                                        name="taxPercent"
                                                        value={addProcurementItemDetails.taxPercent}
                                                        disabled
                                                    />
                                                </div>
                                            </Col>
                                            <Col>
                                                <div className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Taxable
                                                    </Form.Label>
                                                    <Form.Control
                                                        min={0}
                                                        type="number"
                                                        step="any"
                                                        placeholder="In Rupees"
                                                        className="no-arrows"
                                                        name="taxable"
                                                        value={parseFloat(
                                                            addProcurementItemDetails.taxable,
                                                        )?.toFixed(2) || "0.00"}
                                                        disabled
                                                    />
                                                </div>
                                            </Col>
                                            <Col>
                                                <div className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Tax Amount
                                                    </Form.Label>
                                                    <Form.Control
                                                        min={0}
                                                        type="number"
                                                        step="any"
                                                        placeholder="In Rupees"
                                                        className="no-arrows"
                                                        name="taxAmount"
                                                        value={parseFloat(
                                                            addProcurementItemDetails.taxAmount,
                                                        )?.toFixed(2) || "0.00"}
                                                        disabled
                                                    />
                                                </div>
                                            </Col>
                                            <Col>
                                                <div className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Grand Total
                                                    </Form.Label>
                                                    <Form.Control
                                                        min={0}
                                                        type="number"
                                                        step="any"
                                                        placeholder="In Rupees"
                                                        className="no-arrows"
                                                        name="grandTotal"
                                                        value={parseFloat(
                                                            addProcurementItemDetails?.grandTotal || 0
                                                        ).toFixed(2)}
                                                        disabled
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button
                                            type="submit"
                                            disabled={
                                                !addProcurementItemDetails.material ||
                                                !addProcurementItemDetails.quantity ||
                                                !addProcurementItemDetails.actualRate
                                            }
                                        >
                                            {isAddItemBtnLoading ? (
                                                <Spinner size="sm" />
                                            ) : (
                                                "ADD PROCUREMENT ITEM"
                                            )}
                                        </Button>
                                    </Modal.Footer>
                                </Form>
                            </Modal>
                        ) : null}

                        <Modal
                            size="lg"
                            show={openProcurementItemEditModal}
                            onHide={() => setOpenProcurementItemEditModal(false)}
                            centered
                            aria-labelledby="vertically-centered-modal"
                        >
                            <Modal.Header closeButton>
                                <Modal.Title id="vertically-centered-modal" className="fs-6">
                                    EDIT PROCUREMENT ITEM DETAILS
                                </Modal.Title>
                            </Modal.Header>
                            <Form onSubmit={handleEditProcurementItemSubmit}>
                                <Modal.Body>
                                    <Row>
                                        <Col md={4}>
                                            <Form.Label>
                                                Select Material <span className="text-danger">*</span>
                                            </Form.Label>
                                            <div className="mb-3">
                                                <Select
                                                    size="sm"
                                                    name="material"
                                                    className="mb-3"
                                                    options={rawMaterialOptions}
                                                    value={
                                                        rawMaterialOptions.find(
                                                            (rm) =>
                                                                rm.value ===
                                                                editProcurementItemDetails.material,
                                                        ) || null
                                                    }
                                                    onChange={async (selectedOption) => {
                                                        const materialId = selectedOption?.value || "";

                                                        // Update selected material
                                                        handleEditProcurementItemChange(
                                                            "material",
                                                            materialId
                                                        );

                                                        if (materialId) {
                                                            try {
                                                                const headers = {
                                                                    Authorization: `Bearer ${accessToken}`,
                                                                };
                                                                const response = await axios.get(
                                                                    `raw-material?_id=${materialId}`,
                                                                    { headers },
                                                                );

                                                                if (response?.data?.status === true) {
                                                                    const raw = response?.data?.data?.rawMaterials;
                                                                    const taxPercent = raw?.taxPercent || 0;
                                                                    const unit = raw?.unit || "";

                                                                    // Calculate actualRate from rate and quantity
                                                                    const rate = parseFloat(editProcurementItemDetails.rate) || 0;
                                                                    const quantity = parseFloat(editProcurementItemDetails.quantity) || 0;
                                                                    let actualRate = rate;

                                                                    if (unit === "GRAMS" || unit === "ML") {
                                                                        actualRate = rate * quantity;
                                                                    }

                                                                    setEditProcurementItemDetails(prev => ({
                                                                        ...prev,
                                                                        material: materialId,
                                                                        taxPercent,
                                                                        unit,
                                                                        actualRate: Number(actualRate.toFixed(2)),
                                                                    }));
                                                                }
                                                            } catch (error) {
                                                                console.error(
                                                                    "Error fetching raw material details:",
                                                                    error,
                                                                );
                                                                toast.error(
                                                                    "Failed to fetch raw material details",
                                                                );
                                                            }
                                                        } else {
                                                            // If cleared, reset those fields
                                                            setEditProcurementItemDetails(prev => ({
                                                                ...prev,
                                                                taxPercent: 0,
                                                                unit: "",
                                                                actualRate: 0,
                                                            }));
                                                        }
                                                    }}
                                                />
                                                <div className="text-danger">
                                                    {editProcurementItemValidationErrors.material}
                                                </div>
                                            </div>
                                        </Col>

                                        <Col>
                                            <div className="mb-3">
                                                <Form.Label>
                                                    Quantity <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    min={1}
                                                    type="number"
                                                    step="any"
                                                    placeholder="Quantity"
                                                    className="no-arrows"
                                                    name="quantity"
                                                    value={editProcurementItemDetails.quantity}
                                                    onChange={(e) => {
                                                        const quantity = parseFloat(e.target.value) || 0;
                                                        const rate = parseFloat(editProcurementItemDetails.rate) || 0;
                                                        const unit = editProcurementItemDetails.unit;
                                                        const taxPercent = editProcurementItemDetails.taxPercent || 0;

                                                        let actualRate = editProcurementItemDetails.actualRate || 0;

                                                        // Recalculate actualRate based on new quantity
                                                        if (unit === "GRAMS" || unit === "ML") {
                                                            actualRate = rate * quantity;
                                                        }

                                                        const { taxable, taxAmount, grandTotal } = calculateTaxAmount(
                                                            rate,
                                                            quantity,
                                                            taxPercent,
                                                            unit,
                                                            actualRate
                                                        );

                                                        setEditProcurementItemDetails(prev => ({
                                                            ...prev,
                                                            quantity,
                                                            actualRate: Number(actualRate.toFixed(2)),
                                                            taxable,
                                                            taxAmount,
                                                            grandTotal
                                                        }));
                                                    }}
                                                />
                                                <div className="text-danger">
                                                    {editProcurementItemValidationErrors.quantity}
                                                </div>
                                            </div>
                                        </Col>

                                        <Col>
                                            <div className="mb-3">
                                                <Form.Label>
                                                    Unit
                                                </Form.Label>
                                                <Form.Control
                                                    disabled
                                                    type="text"
                                                    placeholder="Unit"
                                                    className="no-arrows"
                                                    name="unit"
                                                    value={editProcurementItemDetails.unit}
                                                />
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col>
                                            <div className="mb-3">
                                                <Form.Label>
                                                    Actual Rate (₹) <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    step="any"
                                                    type="number"
                                                    placeholder="0.00"
                                                    name="actualRate"
                                                    value={editProcurementItemDetails.actualRate || ""}
                                                    onChange={(e) => {
                                                        const actualRate = parseFloat(e.target.value) || 0;
                                                        const quantity = parseFloat(editProcurementItemDetails.quantity) || 0;
                                                        const unit = editProcurementItemDetails.unit;
                                                        const taxPercent = editProcurementItemDetails.taxPercent || 0;

                                                        let rate = actualRate;

                                                        // Calculate rate based on unit
                                                        if ((unit === "GRAMS" || unit === "ML") && actualRate > 0 && quantity > 0) {
                                                            rate = actualRate / quantity;
                                                        }

                                                        rate = Number(rate.toFixed(5));

                                                        const { taxable, taxAmount, grandTotal } = calculateTaxAmount(
                                                            rate,
                                                            quantity,
                                                            taxPercent,
                                                            unit,
                                                            actualRate
                                                        );

                                                        setEditProcurementItemDetails(prev => ({
                                                            ...prev,
                                                            actualRate,
                                                            rate,
                                                            taxable,
                                                            taxAmount,
                                                            grandTotal
                                                        }));
                                                    }}
                                                />
                                            </div>
                                        </Col>

                                        <Col>
                                            <div className="mb-3">
                                                <Form.Label>
                                                    Rate (₹) <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    step="any"
                                                    type="number"
                                                    placeholder="0.00"
                                                    name="rate"
                                                    value={editProcurementItemDetails.rate || ""}
                                                    onChange={(e) => {
                                                        const rate = parseFloat(e.target.value) || 0;
                                                        const quantity = parseFloat(editProcurementItemDetails.quantity) || 0;
                                                        const unit = editProcurementItemDetails.unit;
                                                        const taxPercent = editProcurementItemDetails.taxPercent || 0;

                                                        let actualRate = rate;

                                                        // Calculate actualRate based on unit
                                                        if (unit === "GRAMS" || unit === "ML") {
                                                            actualRate = rate * quantity;
                                                        }

                                                        const { taxable, taxAmount, grandTotal } = calculateTaxAmount(
                                                            rate,
                                                            quantity,
                                                            taxPercent,
                                                            unit,
                                                            actualRate
                                                        );

                                                        setEditProcurementItemDetails(prev => ({
                                                            ...prev,
                                                            rate,
                                                            actualRate: Number(actualRate.toFixed(2)),
                                                            taxable,
                                                            taxAmount,
                                                            grandTotal
                                                        }));
                                                    }}
                                                />
                                                <div className="text-danger">
                                                    {editProcurementItemValidationErrors.rate}
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col>
                                            <div className="mb-3">
                                                <Form.Label>
                                                    Tax Percent
                                                </Form.Label>
                                                <Form.Control
                                                    min={0}
                                                    step="any"
                                                    type="number"
                                                    placeholder="Tax Percent"
                                                    className="no-arrows"
                                                    name="taxPercent"
                                                    value={editProcurementItemDetails.taxPercent}
                                                    disabled
                                                />
                                            </div>
                                        </Col>

                                        <Col>
                                            <div className="mb-3">
                                                <Form.Label>
                                                    Taxable
                                                </Form.Label>
                                                <Form.Control
                                                    min={0}
                                                    step="any"
                                                    type="number"
                                                    placeholder="In Rupees"
                                                    className="no-arrows"
                                                    name="taxable"
                                                    value={editProcurementItemDetails.taxable?.toFixed(2) || "0.00"}
                                                    disabled
                                                />
                                            </div>
                                        </Col>
                                        <Col>
                                            <div className="mb-3">
                                                <Form.Label>
                                                    Tax Amount
                                                </Form.Label>
                                                <Form.Control
                                                    min={0}
                                                    step="any"
                                                    type="number"
                                                    placeholder="In Rupees"
                                                    className="no-arrows"
                                                    name="taxAmount"
                                                    value={editProcurementItemDetails.taxAmount?.toFixed(
                                                        2,
                                                    ) || "0.00"}
                                                    disabled
                                                />
                                            </div>
                                        </Col>
                                        <Col>
                                            <div className="mb-3">
                                                <Form.Label>
                                                    Grand Total
                                                </Form.Label>
                                                <Form.Control
                                                    min={0}
                                                    step="any"
                                                    type="number"
                                                    placeholder="In Rupees"
                                                    className="no-arrows"
                                                    name="quantity"
                                                    value={editProcurementItemDetails.grandTotal?.toFixed(
                                                        2,
                                                    ) || "0.00"}
                                                    disabled
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button type="submit">
                                        {isEditItemBtnLoading ? (
                                            <Spinner size="sm" />
                                        ) : (
                                            "SAVE CHANGES"
                                        )}
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>

                        {openProcurementItemDeleteModal && (
                            <Modal
                                show={openProcurementItemDeleteModal}
                                onHide={() => setOpenProcurementDeleteModal(false)}
                                centered
                                aria-labelledby="vertically-centered-modal"
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title id="vertically-centered-modal" className="fs-6">
                                        DELETE PROCUREMENT ITEM
                                    </Modal.Title>
                                </Modal.Header>
                                <Form onSubmit={handleDeleteProcurementItems}>
                                    <Modal.Body>
                                        Are you sure you want to delete this procurement Item?
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button
                                            variant="warning"
                                            onClick={() => setOpenProcurementDeleteModal(false)}
                                            style={{
                                                background: "#ef9a9a",
                                                outline: "none",
                                                border: "none",
                                            }}
                                        >
                                            Close
                                        </Button>
                                        <Button type="submit">
                                            {isItemDeleteBtnLoading ? (
                                                <Spinner size="sm" />
                                            ) : (
                                                "CONFIRM"
                                            )}
                                        </Button>
                                    </Modal.Footer>
                                </Form>
                            </Modal>
                        )}

                        {openUpdateStatusItemModal && (
                            <Modal
                                show={openUpdateStatusItemModal}
                                onHide={() => setOpenUpdateStatusItemModal(false)}
                                centered
                                aria-labelledby="vertically-centered-modal"
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title id="vertically-centered-modal" className="fs-6">
                                        UPDATE STATUS OF THE PROCUREMENT ITEM
                                    </Modal.Title>
                                </Modal.Header>
                                <Form onSubmit={handleProcurementItemUpdateStatus}>
                                    <Modal.Body>
                                        <p>
                                            Are you sure you want to update the status of this
                                            procurement Item?
                                        </p>

                                        {/* Storage Location Field */}
                                        <Col md={12} className="mt-1">
                                            <Form.Label className="fw-semibold text-muted">
                                                Select Storage Location{" "}
                                                <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Select
                                                components={animatedComponents}
                                                id="selectField"
                                                name="storage_location"
                                                value={storageLocationList
                                                    .map((storage) => ({
                                                        value: storage?._id,
                                                        label: `${storage?.name} -> ${storage?.city}, ${storage?.state}`,
                                                    }))
                                                    .find(
                                                        (option) =>
                                                            option.value === selectedStorageLocation,
                                                    )}
                                                onChange={(selectedOption) =>
                                                    setSelectedStorageLocation(
                                                        selectedOption ? selectedOption.value : "",
                                                    )
                                                }
                                                options={storageLocationList.map((storage) => ({
                                                    value: storage?._id,
                                                    label: `${storage?.name} -> ${storage?.city}, ${storage?.state}`,
                                                }))}
                                                placeholder="Select a Storage Location"
                                                isClearable
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        borderColor: selectedStorageLocation
                                                            ? base.borderColor
                                                            : "red",
                                                    }),
                                                }}
                                            />
                                            {!selectedStorageLocation && (
                                                <span
                                                    className="text-danger d-block"
                                                    style={{ fontSize: "13px" }}
                                                >
                                                    Storage location is required.
                                                </span>
                                            )}
                                        </Col>
                                    </Modal.Body>

                                    <Modal.Footer>
                                        <Button
                                            variant="warning"
                                            onClick={() => setOpenUpdateStatusItemModal(false)}
                                            style={{
                                                outline: "none",
                                                border: "none",
                                                borderRadius: "16px",
                                            }}
                                        >
                                            Close
                                        </Button>
                                        <Button type="submit">
                                            {isItemStatusBtnLoading ? (
                                                <Spinner size="sm" />
                                            ) : (
                                                "UPDATE"
                                            )}
                                        </Button>
                                    </Modal.Footer>
                                </Form>
                            </Modal>
                        )}

                        {openEditStatusWithRemarksModal && (
                            <Modal
                                show={openEditStatusWithRemarksModal}
                                onHide={() => setOpenEditStatusWithRemarksModal(false)}
                                centered
                                aria-labelledby="vertically-centered-modal"
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title id="vertically-centered-modal" className="fs-6">
                                        UPDATE STATUS OF THE PROCUREMENT
                                    </Modal.Title>
                                </Modal.Header>
                                <Form onSubmit={handleEditStatusWithRemarksSubmit}>
                                    <Modal.Body>
                                        <p>
                                            Are you sure you want to update the status of this
                                            procurement?
                                        </p>

                                        <div className="mb-3 mt-4">
                                            <Form.Label>Remark</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows={4}
                                                onChange={(e) => {
                                                    setRemark(e.target.value);
                                                    setValidateRemark("");
                                                }}
                                            />
                                            <div className="text-danger">{validateRemark}</div>
                                        </div>

                                        {/* Storage Location Field */}
                                        <Col md={12} className="mt-1">
                                            <Form.Label className="fw-semibold text-muted">
                                                Select Storage Location{" "}
                                                <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Select
                                                components={animatedComponents}
                                                id="selectField"
                                                name="storage_location"
                                                value={storageLocationList
                                                    .map((storage) => ({
                                                        value: storage?._id,
                                                        label: `${storage?.name} -> ${storage?.city}, ${storage?.state}`,
                                                    }))
                                                    .find(
                                                        (option) =>
                                                            option.value === selectedStorageLocation,
                                                    )}
                                                onChange={(selectedOption) =>
                                                    setSelectedStorageLocation(
                                                        selectedOption ? selectedOption.value : "",
                                                    )
                                                }
                                                options={storageLocationList.map((storage) => ({
                                                    value: storage?._id,
                                                    label: `${storage?.name} -> ${storage?.city}, ${storage?.state}`,
                                                }))}
                                                placeholder="Select a Storage Location"
                                                isClearable
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        borderColor: selectedStorageLocation
                                                            ? base.borderColor
                                                            : "red",
                                                    }),
                                                }}
                                            />
                                            {!selectedStorageLocation && (
                                                <span
                                                    className="text-danger d-block"
                                                    style={{ fontSize: "13px" }}
                                                >
                                                    Storage location is required.
                                                </span>
                                            )}
                                        </Col>
                                    </Modal.Body>

                                    <Modal.Footer>
                                        <Button
                                            variant="danger"
                                            onClick={() => setOpenUpdateStatusModal(false)}
                                            style={{
                                                outline: "none",
                                                border: "none",
                                            }}
                                        >
                                            Close
                                        </Button>
                                        <Button type="submit">
                                            {isEditwithRemarkBtnLoading ? (
                                                <Spinner size="sm" />
                                            ) : (
                                                "UPDATE"
                                            )}
                                        </Button>
                                    </Modal.Footer>
                                </Form>
                            </Modal>
                        )}

                        {/* Add Material Modal */}
                        {showAddModal && (
                            <Modal
                                show={showAddModal}
                                onHide={() => {
                                    setShowAddModal(false);
                                    resetForm()
                                }
                                }
                                size="lg"
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title>ADD NEW RAW MATERIAL</Modal.Title>
                                </Modal.Header>
                                <Form onSubmit={addMaterial}>
                                    <Modal.Body>
                                        <Row className="mb-3">
                                            <Col md={6}>
                                                <Form.Group controlId="formMainCategory" className="mb-3">
                                                    <Form.Label className='fw-semibold'>Main Category <span className="text-danger">*</span></Form.Label>
                                                    <Select
                                                        options={mainCategoryOptions}
                                                        value={mainCategoryOptions.find(opt => opt.value === formData.mainCategory)}
                                                        onChange={(selected) => handleSelectChange(selected, 'mainCategory')}
                                                        isClearable
                                                        isSearchable
                                                        placeholder="Select main category"
                                                        required
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group controlId="formSubCategory" className="mb-3">
                                                    <Form.Label className='fw-semibold'>Sub Category</Form.Label>
                                                    <Select
                                                        options={subCategoryOptions}
                                                        value={subCategoryOptions.find(opt => opt.value === formData.subCategory)}
                                                        onChange={(selected) => handleSelectChange(selected, 'subCategory')}
                                                        isClearable
                                                        isSearchable
                                                        placeholder="Select sub category"
                                                        isDisabled={!formData.mainCategory}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Col md={6}>
                                                <Form.Group controlId="formName" className="mb-3">
                                                    <Form.Label className='fw-semibold'>Name <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="name"
                                                        value={formData.name}
                                                        onChange={handleFormChange}
                                                        placeholder="Enter material name"
                                                        required
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group controlId="formUnit" className="mb-3">
                                                    <Form.Label className='fw-semibold'>Unit <span className="text-danger">*</span></Form.Label>
                                                    <Form.Select
                                                        name="unit"
                                                        value={formData.unit}
                                                        onChange={handleFormChange}
                                                        required
                                                    >
                                                        <option value="">Select unit</option>
                                                        <option value="LITRES">LITRES</option>
                                                        <option value="ML">ML</option>
                                                        <option value="GRAMS">GRAMS</option>
                                                        <option value="KILOGRAMS">KILOGRAMS</option>
                                                        <option value="PACKETS">PACKETS</option>
                                                        <option value="PCS">PCS</option>
                                                        <option value="BOX">BOX</option>
                                                        <option value="NOS">NOS</option>
                                                        <option value="MM">MM</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Col md={6}>
                                                <Form.Group controlId="formHSN" className="mb-3">
                                                    <Form.Label className='fw-semibold'>HSN Code <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="hsn"
                                                        value={formData.hsn}
                                                        onChange={handleFormChange}
                                                        placeholder="Enter HSN code"
                                                        required
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group controlId="formTax" className="mb-3">
                                                    <Form.Label className='fw-semibold'>Tax Percentage <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        name="taxPercent"
                                                        value={formData.taxPercent}
                                                        onChange={handleFormChange}
                                                        min="0"
                                                        max="100"
                                                        placeholder="Enter tax percentage"
                                                        required
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Col>
                                                <Form.Group controlId="formUnit" className="mb-3">
                                                    <Form.Label className='fw-semibold'>Purchase Unit <span className="text-danger">*</span></Form.Label>
                                                    <Form.Select
                                                        name="purchaseUnit"
                                                        value={formData.purchaseUnit}
                                                        onChange={handleFormChange}
                                                        required
                                                    >
                                                        <option value="">Select purchase unit</option>
                                                        <option value="FOOD">Food</option>
                                                        <option value="BEVERAGE">Beverage</option>
                                                        <option value="CENTRAL">Central</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group controlId="formReorder" className="mb-3">
                                                    <Form.Label className='fw-semibold'>Re-Order Level</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        name="reOrderLevel"
                                                        value={formData.reOrderLevel}
                                                        onChange={handleFormChange}
                                                        min="0"
                                                        placeholder="Enter re-order level"
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col>
                                                <Form.Group controlId="formDescription" className="mb-3">
                                                    <Form.Label className='fw-semibold'>Description <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={3}
                                                        name="description"
                                                        value={formData.description}
                                                        onChange={handleFormChange}
                                                        placeholder="Enter description"
                                                        required
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={() => setShowAddModal(false)}>
                                            Cancel
                                        </Button>
                                        <Button variant="warning" type="submit" disabled={isLoading}>
                                            {isLoading ? (
                                                <>
                                                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                                    <span className="ms-2">Adding...</span>
                                                </>
                                            ) : (
                                                "Add Material"
                                            )}
                                        </Button>
                                    </Modal.Footer>
                                </Form>
                            </Modal>
                        )}

                    </div>

                    {/* Render the Add Purchase Modal */}
                    {renderAddPurchaseModal()}
                </Container>
            </div>
        </React.Fragment>
    );
};

export default PurchaseList;
